export const lang_agent = [
  {
    user_key: "Money-out name",
    kurdish: "ناوی پارە دەر",
    arabic: "اسم المال",
    english: "Money-out name",
  },
  {
    user_key: "profile_fname",
    kurdish: "ناوی یەکەم",
    arabic: "الاسم الأول",
    english: "First Name",
  },
  {
    user_key: "email",
    kurdish: "ئیمێڵ",
    arabic: "ئیمێڵ",
    english: "email",
  },
  {
    user_key: "Property Detail",
    kurdish: "زانیاری  موڵك",
    arabic: "معلومات عقار",
    english: "Property Information",
  },
  {
    user_key: "adressOne",
    kurdish: "ناونیشان",
    arabic: "العنوان",
    english: "Address",
  },
  {
    user_key: "Please fill those cells",
    kurdish: "تکایە ئەو خانەیە پڕبکەوە",
    arabic: "يرجى ملء هذه الخلايا..",
    english: "Please fill those cell",
  },
  {
    user_key: "Project Bill List",
    kurdish: "لیستی پسوولەی پڕۆژە",
    arabic: "قائمة فاتورة مشروع",
    english: "Project Bill List",
  },
  {
    user_key: "Anket",
    kurdish: "ئەنکێتەکان",
    arabic: "موافقة اسایش",
    english: "Ankets",
  },
  {
    user_key: "Project Anket",
    kurdish: "ئەنکێتی خزمەتگوزاری پڕۆژە",
    arabic: "ئەنکێتی خزمەتگوزاری پڕۆژە",
    english: "Project Anket",
  },
  {
    user_key: "plus_btn",
    kurdish: "زیادکردن",
    arabic: "إضافة",
    english: "Add",
  },
  {
    user_key: "manager",
    kurdish: "بەڕێوبەر",
    arabic: "مدير",
    english: "Manager",
  },
  {
    user_key: "Role",
    kurdish: "ڕۆڵ",
    arabic: "دور",
    english: "Role",
  },
  {
    user_key: "s_login",
    kurdish: "چوونەژوورەوە",
    arabic: "تسجيل الدخول",
    english: "Login",
  },
  {
    user_key: "To write",
    kurdish: "نووسراو",
    arabic: "الكتابة",
    english: "writing",
  },
  {
    user_key: "Writing No",
    kurdish: "ژ.نووسراو",
    arabic: "ر.الكتابة",
    english: "Writing No",
  },
  {
    user_key: "subject",
    kurdish: "بابەت",
    arabic: "موضوع",
    english: "subject",
  },
  {
    user_key: "List of Scripts",
    kurdish: "لیستی نووسراوەکان",
    arabic: "قائمة البرامج النصية",
    english: "List of Scripts",
  },
  // new one
  {
    user_key: "The gas station",
    kurdish: "بەنزینخانە",
    arabic: "محطة الوقود.",
    english: "The gas station.",
  },
  {
    user_key: "Strecture",
    kurdish: "هەیکەل",
    arabic: "هیکل",
    english: "Strecture",
  },
  {
    user_key: "Factory",
    kurdish: "کارگە",
    arabic: "مصنع",
    english: "Factory.",
  },
  {
    user_key: "Car wash",
    kurdish: "شووشتنگەی ئۆتۆمبێل",
    arabic: "غسيل السيارات",
    english: "Car wash",
  },
  {
    user_key: "GYM",
    kurdish: "هۆڵی لەشجوانی",
    arabic: "قاعة كمال الاجسام",
    english: "GYM.",
  },
  {
    user_key: "store",
    kurdish: "کۆگا",
    arabic: "مخزن",
    english: "store.",
  },
  {
    user_key: "Restaurant",
    kurdish: "چێشتخانە",
    arabic: "مطعم",
    english: "Restaurant.",
  },
  {
    user_key: "palace",
    kurdish: "کۆشک",
    arabic: "قصر",
    english: "palace",
  },
  {
    user_key: "phone_number",
    kurdish: "ژمارەی مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "third_rule_introduction",
    kurdish: "وەرگرت وەک پێشەکی، وە بڕی پارە ماوە ",
    arabic: "كمقدمة، و المبلغ المتبقي",
    english: "in advance, and the rest of money will be ",
  },
  {
    user_key: "as a condition of punishment",
    kurdish: "وەکوو مەرجی سزا ",
    arabic: "كشرط للعقاب ",
    english: "as a condition of punishment ",
  },
  {
    user_key: "profile_lname",
    kurdish: "ناوی دووەم",
    arabic: "الاسم الثاني",
    english: "Last Name",
  },
  {
    user_key: "addproperty",
    kurdish: "زیادکردنی موڵك",
    arabic: "اضافة عرض",
    english: "Add Property",
  },

  {
    user_key: "add_Required_property",
    kurdish: "زیادکردنی داواکاری موڵك",
    arabic: "اضافة طلب عقار",
    english: "Add Required Property",
  },
  {
    user_key: "add_Required",
    kurdish: "داواکاری موڵك",
    arabic: "طلبات العقار",
    english: "Add Required",
  },
  {
    user_key: "update_property_sell",
    kurdish: "دەستکاری کردنی موڵکی فرۆشتن",
    arabic: "تعديل",
    english: "Update Sell Property ",
  },
  {
    user_key: "update_property_rent",
    kurdish: "دەستکاری کردنی موڵکی کرێ",
    arabic: "تعديل عقارات الإيجار",
    english: "Update Rent Property",
  },
  {
    user_key: "profile_gender",
    kurdish: "ڕەگەز",
    arabic: "الجنس",
    english: "Gender",
  },
  {
    user_key: "profile_mob",
    kurdish: "مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "invoice_mob",
    kurdish: "ژمارەی مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "invoice_mob_tenat",
    kurdish: "ژمارەی مۆبایل",
    arabic: "هاتف المستأجر",
    english: "Mobile Number",
  },
  {
    user_key: "Caller Mobile",
    kurdish: "مۆبایلی داواکار",
    arabic: "المتصل موبايل",
    english: "Caller Mobile",
  },
  {
    user_key: "cash",
    kurdish: "کاش",
    arabic: "نقدي",
    english: "cash",
  },
  {
    user_key: "Applicant's name",
    kurdish: "ناوی داواکار",
    arabic: "اسم مقدم الطلب",
    english: "Applicant's name",
  },
  {
    user_key: "Contract Organizer",
    kurdish: "ڕێکخەری گرێبەست",
    arabic: "منظم العقد",
    english: "Contract Organizer",
  },
  {
    user_key: "List of Tenants",
    kurdish: "لیستی کرێچیەکان",
    arabic: "قائمة المستأجرين",
    english: "List of Tenants",
  },
  {
    user_key: "information",
    kurdish: "زانیاری",
    arabic: "معلومات",
    english: "Information",
  },
  {
    user_key: "Purchase Type",
    kurdish: "جۆری کڕین",
    arabic: "نوع الشراء",
    english: "Purchase Type",
  },
  {
    user_key: "profile_location",
    kurdish: "شوێن",
    arabic: "الموقع",
    english: "Location",
  },
  {
    user_key: "Account Details",
    kurdish: "زانیاری کەسی",
    arabic: "معلومات شخصية",
    english: "Personal information",
  },
  {
    user_key: "active",
    kurdish: "چاڵاك",
    arabic: "متاح",
    english: "Active",
  },
  {
    user_key: "deactive",
    kurdish: "ناچاڵاك",
    arabic: "غير متاح",
    english: "DeActive",
  },
  {
    user_key: "rented",
    kurdish: "بەکرێدراو",
    arabic: "مؤجر",
    english: "rented",
  },
  {
    user_key: "sold",
    kurdish: "فرۆشراو",
    arabic: "مباع",
    english: "sold",
  },
  {
    user_key: "suspend",
    kurdish: "ڕاگیراو",
    arabic: "معلق",
    english: "Suspend",
  },
  {
    user_key: "profile_updatebt",
    kurdish: "نویکردنەوە",
    arabic: "تحديث",
    english: "Update",
  },
  {
    user_key: "Logged_in_Yet",
    kurdish: "ئایە داخل بووە",
    arabic: "تم تسجيل الدخول من قبل",
    english: "Logged in Yet",
  },
  {
    user_key: "Agents",
    kurdish: "وەکیل",
    arabic: "الوكيل",
    english: "Agents",
  },
  {
    user_key: "agent",
    kurdish: "وەکیل",
    arabic: "الوكيل",
    english: "agent",
  },
  {
    user_key: "Agent_name",
    kurdish: "ناوی وەکیل",
    arabic: "اسم الوكيل",
    english: "Agent Name",
  },
  {
    user_key: "Agents_List",
    kurdish: "لیستی وەکیلەکان",
    arabic: "قائمة الوكلاء",
    english: "Agents List",
  },
  {
    user_key: "Create Agent",
    kurdish: "دروستکردنی وەکیل",
    arabic: "إضافة وكيل",
    english: "Create Agent",
  },
  {
    user_key: "Branches",
    kurdish: "لقەکان",
    arabic: " الفروع",
    english: "Branches",
  },
  {
    user_key: "Account",
    kurdish: "زانیاری کەسی",
    arabic: "معلومات شخصية",
    english: "Account Information",
  },
  {
    user_key: "Name of Branch",
    kurdish: "ناوی لق",
    arabic: " اسم الفرع",
    english: "Name of Branch",
  },
  {
    user_key: "Create Branch",
    kurdish: "دروستکردنی لق",
    arabic: " إضافة فرع",
    english: "Create Branch",
  },
  {
    user_key: "List Branches",
    kurdish: "لیستی لقەکان",
    arabic: "قائمة الفروع",
    english: "List Branches",
  },
  {
    user_key: "save",
    kurdish: "خەزن کردن",
    arabic: "حفظ",
    english: "Save",
  },
  {
    user_key: "password_updatebt",
    kurdish: "نویکردنەوە",
    arabic: "تحديث",
    english: "Update",
  },
  {
    user_key: "password",
    kurdish: "وشەی نهێنی ",
    arabic: "كلمة المرور ",
    english: "Password",
  },
  {
    user_key: "password_change",
    kurdish: "نویکردنەوەی پاسوورد",
    arabic: "تغيير كلمة المرور",
    english: "Change Password",
  },
  {
    user_key: "id",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "ID",
  },
  {
    user_key: "id_branch",
    kurdish: "ژمارەی لق",
    arabic: "معرف الفرع",
    english: "Branch ID",
  },
  {
    user_key: "id_branch_agent",
    kurdish: "وەکیل ID",
    arabic: "معرف الوكيل",
    english: "Agent ID",
  },
  {
    user_key: "Search",
    kurdish: "گەڕان",
    arabic: "بحث",
    english: "Search",
  },
  {
    user_key: "Old_Password",
    kurdish: "وشەی نهێنی کۆن",
    arabic: "كلمة المرور القديمة",
    english: "Old Password",
  },
  {
    user_key: "New_Password",
    kurdish: "وشەی نهێنی نوێ",
    arabic: "كلمة المرور الجديدة",
    english: "New Password",
  },
  {
    user_key: "new_page",
    kurdish: "پەڕەی نوێ",
    arabic: "صفحة جديدة",
    english: "New Page",
  },
  // Dashboard
  {
    user_key: "d_earnings",
    kurdish: "قازانج",
    arabic: "فوائد",
    english: "Benefits",
  },
  {
    user_key: "d_products",
    kurdish: "کالایەکان",
    arabic: "منتجات",
    english: "Products",
  },
  {
    user_key: "d_totalorders",
    kurdish: "داواکاریەکان",
    arabic: "إجمالي الطلبات",
    english: "Total orders",
  },
  {
    user_key: "d_lorders",
    kurdish: "نوێترین داواکاریەکان",
    arabic: "أحدث الطلبات",
    english: "Latest Orders",
  },
  {
    user_key: "d_orderid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "Order Id",
  },
  {
    user_key: "d_payment",
    kurdish: "جۆری پارەدان",
    arabic: "طريقة الدفع",
    english: "Payment Method",
  },
  {
    user_key: "d_status",
    kurdish: "بار",
    arabic: "الحالة",
    english: "Status",
  },
  {
    user_key: "d_total",
    kurdish: "کۆی گشتی",
    arabic: "المجموع",
    english: "Total",
  },
  {
    user_key: "Buy",
    kurdish: "کڕین",
    arabic: "نقدي",
    english: "Buy",
  },
  {
    user_key: "d_viewall",
    kurdish: "بینینی هەمووی",
    arabic: "عرض الجميع",
    english: "View All",
  },
  {
    user_key: "d_view",
    kurdish: "بینین",
    arabic: "عرض",
    english: "View",
  },
  {
    user_key: "d_totalsales",
    kurdish: "کۆی فرۆشتنەکان",
    arabic: "إجمالي المبيعات",
    english: "Total Sales",
  },
  {
    user_key: "d_totalqazanj",
    kurdish: "کۆی گشتیی قازانج",
    arabic: "إجمالي الفوائد",
    english: "Total Benefits",
  },
  {
    user_key: "d_saleslm",
    kurdish: "فرۆشتنەکانی مانگی پێشوو",
    arabic: "مبيعات الشهر الماضي",
    english: "Last Month Sales",
  },
  {
    user_key: "d_purchasem",
    kurdish: "قازانجی مانگی پێشوو",
    arabic: "مشتريات الشهر الماضي",
    english: "Last Month Purchases",
  },
  {
    user_key: "d_productrate",
    kurdish: "هەلسەنگادنی کالاکان",
    arabic: "تقييم المنتج",
    english: "Product Rate",
  },
  {
    user_key: "d_productratelevel",
    kurdish: "ئاست",
    arabic: "مستوى",
    english: "Level",
  },
  {
    user_key: "d_productname",
    kurdish: "ناو",
    arabic: "اسم",
    english: "Name",
  },
  {
    user_key: "d_productid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "Product id",
  },
  {
    user_key: "Company Name",
    kurdish: "ناوی کۆمپانیا",
    arabic: "اسم الشركة",
    english: "Company Name",
  },
  {
    user_key: "Company Address",
    kurdish: "ناونیشانی کۆمپانیا",
    arabic: "عنوان الشركة",
    english: "Company Address",
  },
  {
    user_key: "Company owner's name",
    kurdish: "ناوی خاوەن کۆمپانیا",
    arabic: "اسم مالك الشركة",
    english: "Company owner's name",
  },
  {
    user_key: "Number",
    kurdish: "ژمارە",
    arabic: "الرقم",
    english: "Number",
  },
  // product list
  {
    user_key: "pr_productid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "ID",
  },
  {
    user_key: "pr_image",
    kurdish: "وێنە",
    arabic: "صورة",
    english: "Image",
  },
  {
    user_key: "pr_name",
    kurdish: "ناو",
    arabic: "اسم",
    english: "Name",
  },
  {
    user_key: "pr_size",
    kurdish: "قەبارە",
    arabic: "الحجم",
    english: "Size",
  },
  {
    user_key: "pr_quantity",
    kurdish: "دانە",
    arabic: "العدد",
    english: "Quantity",
  },
  {
    user_key: "s_kryar",
    kurdish: "ناوی کڕیار",
    arabic: "المشتري",
    english: "buyer name",
  },
  {
    user_key: "pr_price",
    kurdish: "نرخ",
    arabic: "السعر",
    english: "Price",
  },
  {
    user_key: "pr_color",
    kurdish: "ڕەنگ",
    arabic: "اللون",
    english: "Color",
  },
  {
    user_key: "pr_productlist",
    kurdish: "لیستی کاڵاکان",
    arabic: "قائمة المنتجات",
    english: "Product List",
  },
  {
    user_key: "next",
    kurdish: "دواتر",
    arabic: "التالي",
    english: "Next",
  },
  {
    user_key: "previous",
    kurdish: "پێشتر",
    arabic: "السابق",
    english: "Previous",
  },
  {
    user_key: "date",
    kurdish: "بەروار",
    arabic: "التاريخ",
    english: "Date",
  },
  {
    user_key: "todo",
    kurdish: "ئەنجامدان",
    arabic: "قائمة المهام",
    english: "To Do",
  },
  {
    user_key: "manageorder",
    kurdish: "ڕێکخستنی داواکاریەکان",
    arabic: "إدارة الطلبات",
    english: "Manage Orders",
  },
  {
    user_key: "pr_action",
    kurdish: "دەستکاری",
    arabic: "تعديل",
    english: "Edit",
  },
  {
    user_key: "tr_amount",
    kurdish: "بڕی پارە",
    arabic: "المبلغ",
    english: "Amount",
  },
  {
    user_key: "transactionid",
    kurdish: "ژمارەی پارەدان",
    arabic: "رقم المبلغ",
    english: "Transaction_ID",
  },
  {
    user_key: "paredan",
    kurdish: "پارەدان",
    arabic: "الدفع",
    english: "Payment_ID",
  },
  {
    user_key: "transaction",
    kurdish: "پارەدانەکان",
    arabic: "المدفوعات",
    english: "payment details",
  },
  {
    user_key: "in_no",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "No",
  },
  {
    user_key: "in_invoice",
    kurdish: "ژمارەی پسولە",
    arabic: "رقم الفاتورة",
    english: "Invoice No",
  },
  {
    user_key: "in_shipping",
    kurdish: "نرخی گواستنەوە",
    arabic: "مبلغ التوصيل",
    english: "Shipping",
  },
  {
    user_key: "s_dashboard",
    kurdish: "داشبۆرد",
    arabic: "الصفحة الرئيسية",
    english: "Dashboard",
  },
  {
    user_key: "property",
    kurdish: "مووڵکەکان",
    arabic: "العقارات",
    english: "Property",
  },
  {
    user_key: "property_just",
    kurdish: "موڵك",
    arabic: "العقار",
    english: "Property",
  },
  {
    user_key: "transfer_orders",
    kurdish: "گواستنەوەی داواکاریەکان",
    arabic: "تحويل الطلبات",
    english: "Transfer_Orders",
  },
  {
    user_key: "sending_orders",
    kurdish: "ناردنی داواکاریەکان",
    arabic: "إرسال الطلبات",
    english: "Sending Orders",
  },
  {
    user_key: "order_from",
    kurdish: "داواکاری لە",
    arabic: "طلب من",
    english: "Order From",
  },
  {
    user_key: "from",
    kurdish: "لە",
    arabic: "من",
    english: "In",
  },
  {
    user_key: "to",
    kurdish: "بۆ",
    arabic: "الی",
    english: "To",
  },
  {
    user_key: "to__",
    kurdish: "بۆ",
    arabic: "ولغاية",
    english: "To",
  },
  {
    user_key: "order_to",
    kurdish: "داواکاری بۆ",
    arabic: "طلب الی",
    english: "Order To",
  },
  {
    user_key: "s_transactions",
    kurdish: "پارەدانەکان",
    arabic: "المدفوعات",
    english: "payment",
  },
  {
    user_key: "s_reports",
    kurdish: "راپۆرتەکان",
    arabic: "التقارير",
    english: "Reports",
  },
  {
    user_key: "s_pending",
    kurdish: "داواکاریە نوێیەکان",
    arabic: "طلبات معلقة",
    english: "Pending orders",
  },
  {
    user_key: "s_settings",
    kurdish: "رێکخستنەکان",
    arabic: "إعدادات",
    english: "Settings",
  },
  {
    user_key: "s_profile",
    kurdish: "لاپەرەی کەسی",
    arabic: "الملف الشخصي ",
    english: "Profile",
  },
  {
    user_key: "s_invoice",
    kurdish: "پسولە",
    arabic: "فواتير",
    english: "Invoice",
  },
  {
    user_key: "s_logout",
    kurdish: "چونەدەرەوە",
    arabic: "تسجيل الخروج",
    english: "Logout",
  },
  {
    user_key: "Update Image",
    kurdish: "گۆڕینی وێنە",
    arabic: " تحديث الصورة",
    english: "Update Image",
  },
  {
    user_key: "ToDo List",
    kurdish: "لیستی ئەرکەکان",
    arabic: "قائمة المهام",
    english: "Inprogress",
  },
  {
    user_key: "incompany",
    kurdish: "لە  عقارات",
    arabic: "في الشركة",
    english: "In_company",
  },
  {
    user_key: "In",
    kurdish: "لە",
    arabic: "في",
    english: "In",
  },
  {
    user_key: "add_desc",
    kurdish: "دەربارەی موڵک",
    arabic: "وصف العقار",
    english: "Description",
  },
  {
    user_key: "add_buttoncl",
    kurdish: "رەشکردنەوە",
    arabic: "مسح",
    english: "Delete",
  },
  {
    user_key: "Choose",
    kurdish: "هەلبژێرە",
    arabic: "إختر",
    english: "Choose",
  },
  {
    user_key: "discount",
    kurdish: "داشکان",
    arabic: "خصم",
    english: "Discount",
  },
  {
    user_key: "Sell",
    kurdish: "فرۆشتن",
    arabic: "بيع",
    english: "Sell",
  },
  {
    user_key: "cancel",
    kurdish: "پاشگەربوون",
    arabic: "إلغاء",
    english: "cancel",
  },
  {
    user_key: "back",
    kurdish: "گەڕانەوە",
    arabic: "عودة",
    english: "Back",
  },
  {
    user_key: "accept",
    kurdish: "پەسەندکردن",
    arabic: "قبول",
    english: "Accept",
  },
  // colors
  /**
   * new agent
   */
  {
    user_key: "cardNo",
    kurdish: "ژمارەی کارت",
    arabic: "رقم البطاقة",
    english: "CardNo",
  },
  {
    user_key: "passportNo",
    kurdish: "ژمارەی پاسپۆرت",
    arabic: "رقم جواز السفر",
    english: "PassportNo",
  },

  /// add property

  {
    user_key: "Sell",
    kurdish: "فرۆشتن",
    arabic: "بيع",
    english: "Sell",
  },
  {
    user_key: "Type of property",
    kurdish: "جۆری موڵك",
    arabic: "نوع العقار",
    english: "Type of property",
  },
  {
    user_key: "Place (Kurdish)",
    kurdish: "شوێن (کوردی)",
    arabic: "الموقع (كردي)",
    english: "Place (Kurdish)",
  },
  {
    user_key: "Place (Arabic)",
    kurdish: "شوێن (عربي)",
    arabic: "الموقع (عربي)",
    english: "Place (Arabic)",
  },
  {
    user_key: "Place (English)",
    kurdish: "شوێن (ئینگلیزی)",
    arabic: "الموقع (إنجليزي)",
    english: "Place (English)",
  },
  {
    user_key: "Area_",
    kurdish: "م²/ ڕووبەر ",
    arabic: "المساحة / م²",
    english: "Area/m²",
  },
  {
    user_key: "Area",
    kurdish: "ڕووبەر",
    arabic: "المساحة",
    english: "Area",
  },
  {
    user_key: "‌holded_by",
    kurdish: "گرتراوە لەلایەن",
    arabic: "عجز من",
    english: "Holded By",
  },
  {
    user_key: "Company Branch",
    kurdish: "لقی   عقارات",
    arabic: "فرع الشركة",
    english: "Company Branch",
  },
  {
    user_key: "Description (Kurdish)",
    kurdish: "دەربارەی موڵك (کوردی)",
    arabic: "تفاصيل العقار (كردي)",
    english: "Description (Kurdish)",
  },
  {
    user_key: "Description (Arabic)",
    kurdish: "دەربارەی موڵك (عربي)",
    arabic: "تفاصيل (عربي)",
    english: "Description (Arabic)",
  },
  {
    user_key: "Description (English)",
    kurdish: "دەربارەی موڵك (ئینگلیزی)",
    arabic: "تفاصيل العقار (إنجليزي)",
    english: "Description (English)",
  },
  {
    user_key: "Description",
    kurdish: "دەربارەی موڵك",
    arabic: "الوصف",
    english: "Description",
  },
  {
    user_key: "Description_",
    kurdish: "دەربارەی خزمەتگوزاری",
    arabic: "الوصف",
    english: "Description",
  },
  {
    user_key: "Rent",
    kurdish: "کرێ",
    arabic: "إيجار",
    english: "Rent",
  },
  /**
   * property type
   */
  {
    user_key: "Apartment",
    kurdish: "شوقە",
    arabic: "شقة",
    english: "Apartment",
  },
  {
    user_key: "House",
    kurdish: "خانوو",
    arabic: "منزل",
    english: "House",
  },
  {
    user_key: "Farm",
    kurdish: "باخ",
    arabic: "مزرعة",
    english: "Farm",
  },
  {
    user_key: "Shop",
    kurdish: "دوکان",
    arabic: "متجر",
    english: "Shop",
  },
  {
    user_key: "Vella",
    kurdish: "ڤێلا",
    arabic: "فيلا",
    english: "Vella",
  },
  // new
  {
    user_key: "Company",
    kurdish: "پێشانگا",
    arabic: "معرض",
    english: "Company",
  },
  {
    user_key: "Hotel",
    kurdish: "هۆتێل",
    arabic: "فندق",
    english: "Hotel",
  },
  {
    user_key: "Commercial Land",
    kurdish: "زەوی بازرگانی",
    arabic: "أرض تجارية",
    english: "Commercial Land",
  },
  {
    user_key: "Car Garage",
    kurdish: "گەراجی ئۆتۆمبێل",
    arabic: "كراج سيارات",
    english: "Car Garage",
  },
  {
    user_key: "Stadium",
    kurdish: "یاریگا",
    arabic: "ملعب",
    english: "Stadium",
  },
  /**
   * end
   */
  {
    user_key: "buyer_name",
    kurdish: "ناوی کڕیار",
    arabic: "اسم المشتري",
    english: "Buyer Name",
  },
  {
    user_key: "buyer_phone",
    kurdish: "مۆبایلی کڕیار",
    arabic: "هاتف المشتري",
    english: "Buyer Phone",
  },
  {
    user_key: "Owner Name",
    kurdish: "ناوی خاوەن موڵك",
    arabic: "اسم المالك",
    english: "Owner Name",
  },
  {
    user_key: "Owner Phone",
    kurdish: "مۆبایلی خاوەن موڵك",
    arabic: "هاتف المالك",
    english: "Owner Phone",
  },
  {
    user_key: "General",
    kurdish: "گشتی",
    arabic: "عام",
    english: "General",
  },
  {
    user_key: "Add",
    kurdish: "زیادکردن",
    arabic: "إضافة",
    english: "Add",
  },
  {
    user_key: "Owner Detail",
    kurdish: "زانیاری خاوەن موڵك",
    arabic: "معلومات المالك",
    english: "Owner Information",
  },
  {
    user_key: "Buyer_Detail",
    kurdish: "زانیاری کەسی کڕیار",
    arabic: "معلومات المشتري",
    english: "Buyer Information",
  },
  {
    user_key: "Add Description",
    kurdish: "دەربارەی موڵك",
    arabic: "إضافة وصف",
    english: "Add Description",
  },
  {
    user_key: "Image Upload",
    kurdish: "تۆمارکردنی وێنە",
    arabic: "تحميل صورة",
    english: "Image Upload",
  },
  {
    user_key: "Sell Property List",
    kurdish: "لیستی فرۆشتنی موڵکەکان",
    arabic: "قائمة عقارات البيع",
    english: "Sell Property List",
  },
  {
    user_key: "Sell List",
    kurdish: "لیستی فرۆشتن",
    arabic: " عروض البيع",
    english: "Sell List",
  },
  {
    user_key: "Rent Property List",
    kurdish: "لیستی بەکرێدانی موڵکەکان",
    arabic: "قائمة عقارات الإيجار",
    english: "Rent Property List",
  },
  {
    user_key: "Rent List",
    kurdish: "لیستی کرێ ",
    arabic: "عروض الإيجار",
    english: "Rent List",
  },
  {
    user_key: "Property List",
    kurdish: "لیستی موڵکەکان",
    arabic: "قائمة العقارات ",
    english: "Property List",
  },
  {
    user_key: "View_Property",
    kurdish: "بینینی موڵك",
    arabic: "عرض العقارات",
    english: "View Property",
  },
  {
    user_key: "View_Property_required",
    kurdish: "بینینی داواکاری موڵك",
    arabic: "عقارات مطلوبة",
    english: "View Required Property",
  },

  ///
  {
    user_key: "Buy_Required",
    kurdish: "داواکراوی کڕین",
    arabic: "طلب شراء",
    english: "Buy Required",
  },
  {
    user_key: "Buy_Required_translation",
    kurdish: "کڕین",
    arabic: "شراء",
    english: "Buy",
  },
  {
    user_key: "Arabun",
    kurdish: "عربون",
    arabic: " عربون",
    english: "Arabun",
  },
  {
    user_key: "Buy Required Property",
    kurdish: "لیستی کڕینی موڵکی داواکراو",
    arabic: " قائمة طلبات الشراء",
    english: "Buy Required",
  },
  {
    user_key: "Rent_Required",
    kurdish: "داواکراوی کرێ",
    arabic: "طلب إيجار",
    english: "Rent Required",
  },
  {
    user_key: "Rent Required Property",
    kurdish: "لیستی موڵکی کرێی داواکراو",
    arabic: "قائمة طلبات الإيجار",
    english: "Rent Required List",
  },
  {
    user_key: "Required Property List",
    kurdish: "لیستی موڵکی داواکراو",
    arabic: "قائمة العقارات المطلوبة ",
    english: "Required List",
  },

  /// invoice
  {
    user_key: "agreement",
    kurdish: "هەردوو لایەن رێککەوتن لەسەر ئەم خاڵانەی خوارەوە",
    arabic: "إتفق الطرفان على ما يلي",
    english: "Both parties agreed on these terms",
  },
  {
    user_key: "Second Party (Buyer)",
    kurdish: "لایەنی دووەم (کڕیار)",
    arabic: "الطرف الثاني ( المشتري)",
    english: "Second Party (Buyer)",
  },

  {
    user_key: "First Party (Seller)",
    kurdish: "لایەنی یەکەم (فرۆشیار)",
    arabic: "الطرف الأول ( البائع)",
    english: "First Party (Seller)",
  },
  {
    user_key: "First Party (Seller)_",
    kurdish: "لایەنی یەکەم (فرۆشیار)",
    arabic: " (البائع) الطرف الأول",
    english: "First Party (Seller)",
  },
  {
    user_key: "Second Party (Buyer)_",
    kurdish: "لایەنی دووەم (کڕیار)",
    arabic: "الطرف الثاني (المشتري)",
    english: "Second Party (Buyer)",
  },
  {
    user_key: "Second Party (Buyer)_A",
    kurdish: "لایەنی دووەم (کڕیار)",
    arabic: "الطرف الثاني المشتري",
    english: "Second Party (Buyer)",
  },

  {
    user_key: "First Party (Seller)_A",
    kurdish: "لایەنی یەکەم (فرۆشیار)",
    arabic: "الطرف الأول البائع",
    english: "First Party (Seller)",
  },
  {
    user_key: "First Party",
    kurdish: "لایەنی یەکەم",
    arabic: "الطرف الأول ",
    english: "First Party",
  },
  {
    user_key: "sale and purchase contract",
    kurdish: "گرێبەستی کڕین و فرۆشتن",
    arabic: "عقد البيع والشراء",
    english: "Buy and Sale Contract",
  },
  {
    user_key: "Rental contract",
    kurdish: "گرێبەستی کرێ",
    arabic: "عقود الإيجار",
    english: "Rent Contract",
  },
  {
    user_key: "contract number",
    kurdish: "ژمارەی گرێبەست",
    arabic: "رقم العقد",
    english: "contract number",
  },
  {
    user_key: "View Recontract",
    kurdish: "دووبارە گرێبەستکردن",
    arabic: "إعادة التعاقد",
    english: "View Recontract",
  },
  {
    user_key: "first_rule_price",
    kurdish:
      "من لایەنی یەکەم خاوەنی موڵک ڕازیم بە فرۆشتنی ئەم موڵکەی لە خوارەوە ئاماژەی پێکراوە بە بڕی",
    arabic:
      "اني الطرف الأول (مالك العقار) اقر بانني قد بعت ھذا العقار المدون أدناه بمبلغ قدره",
    english:
      "As an owner to the estate, I agree to sell the estate as detailed below for on amount of",
  },
  {
    user_key: "first_rule_Property_type",
    kurdish: "جۆری موڵک",
    arabic: "نوع العقار",
    english: "estate type",
  },
  {
    user_key: "Close",
    kurdish: "داخستن",
    arabic: "يغلق",
    english: "Close",
  },
  {
    user_key: "type",
    kurdish: "جۆر",
    arabic: "نوع",
    english: "Type",
  },
  {
    user_key: "first_rule_place",
    kurdish: "شوێن",
    arabic: "الموقع",
    english: "Location",
  },
  {
    user_key: "second_rule_price",
    kurdish:
      "من لایەنی دووەم ڕازیم بە کڕینی ئەو موڵکەی لە سەرەوە ئاماژەی پێکراوە بە بڕی",
    arabic:
      "اني الطرف الثاني اقره بانني قد اشتريت ھذا العقار المدون أعلاه بمبلغ قدره",
    english:
      " I am (as a second party) agreed to buy this estate as mentioned above for on amount of",
  },
  {
    user_key: "third_rule_price",
    kurdish: "لایەنی یەکەم بڕی ",
    arabic: "استلم الطرف الاول مبلغ",
    english: "The first party has taken amount of",
  },
  {
    user_key: "third_rule_introduction",
    kurdish: "وەرگرت وەک پێشەکی، وە بڕی پارە ماوە ",
    arabic: "كمقدمة، و المبلغ المتبقي",
    english: "in advance, and the rest of money will be ",
  },
  {
    user_key: "forth_rule_date",
    kurdish:
      "لایەنی یەکەم پێویستە ئەم موڵکە ڕادەستی لایەنی دووەم بکات تا ڕێکەوتی ",
    arabic: "على الطرف الاول تسليم العقار الى الطرف الثاني بتاريخ",
    english:
      "The first party needs to give the estate to the second party until",
  },
  {
    user_key: "fifth_rule_price",
    kurdish:
      "ئەگەر هاتوو لایەنی یەکەم لە ڕێکەوتی دیاریکراودا ئەم مووڵکە ڕادەستی لایەنی دووەم نەکرد ئەوا دەبێت پابەندبێت بە پێدانی بڕی",
    arabic:
      "اذا تأخر تسليم العقار الى الطرف الثاني، يتحمل الطرف الاول غرامة يومية بمبلغ",
    english:
      "If the first party couldn’t give the estate to the second party at the defined time above, the first party must pay about",
  },
  {
    user_key: "seven_rule",
    kurdish:
      "ڕسوماتیی فرۆشتن و گواستنەوە و جیاکردنەوە و یەکخستن و ڕادەستکردنەوە و باجی خانووبەرە لەسەر لایەنی یەکەمە کە بیدات بە پێی یاسا ئەگەر تاپۆ بوو، وە ئەگەر تاپۆ نەبوو لایەنی یەکەم و دووەم پابەندن بە پێدانی پارەی بەناو کردن. ",
    arabic:
      "يتحمل الطرف الأول تسديد مبالغ رسوم البيع والنقل والتمييز والتنسيق وضريبة العقار وكل ما عليه حسب القانون.",
    english:
      "Fees of buying, transportation, differentiation, coordination, amendment, and estate fees should be paid by the first party if the property was officially registered. Whereas, if it is not registered, then the seller and buyer are responsible for registering it.",
  },
  {
    user_key: "eight_rule",
    kurdish:
      "ڕسوماتی کەشف و تۆماری عەقاری دەکەوێتە سەر لایەنی دووەم بە گوێرەی یاسا ئەگەر موڵکەکە تاپۆ بوو، وە ئەگەر تاپۆ نەبوو ئەوا لایەنی یەکەم و دووەم پابەندن بە پێدانی بڕی پارەی بەناوکردن ",
    arabic:
      "على الطرف الثاني تسديد رسوم الكشف والتسجيل العقاري و كل ما عليه حسب القانون.",
    english:
      " Property valuation and registration should be paid by the second party if the property was officially registered. Whereas, if it is not registered, then the seller and buyer are responsible for registering it.",
  },
  {
    user_key: "ten_rule_one",
    kurdish:
      "هەردوو لایەن پابەندن بە پێدانی ڕێژەی 1% لە نرخی ئەم موڵکەی سەرەوە بە  دیڤاین  لە بەرامبەر فرۆشتنی ئەم موڵكە.",
    arabic:
      "يلتزم كل طرف بدفع مبلغ 1% من سعر كلفة الدار اعلاه الى عقارات شكوي زوي و ذلك مقابل التوسط في بيع الملك. ",
    english:
      "Both parties are committed to pay 1% of the property price to Homle Real Estate Company agency for selling this property.",
  },
  {
    user_key: "ten_rule_thirs",
    kurdish: " نرخی تێچووی خانووەکەی سەرەوە بداتە   عقارات",
    arabic: " من سعر كلفة الدار اعلاه الى شركة ",
    english: "of the cost price of the house above to",
  },
  {
    user_key: "ten_rule_four",
    kurdish: "کە دەکاتە",
    arabic: "وهو ما تفعله.",
    english: "which it does",
  },
  {
    user_key: "ten_rule_two",
    kurdish: " ئەوەش لە بەرامبەر نێوەندگیریی رێکخستنی ئەم گرێبەستە",
    arabic: " و ذلك مقابل التوسط في ایجار العقار",
    english: "in return for mediating in the Rent of the property",
  },

  {
    user_key: "nine_rule_two",
    kurdish:
      ".بە بریکارنامەی تایبەت بەم موڵکە لە فەرمانگەی دادنووس بە مەبەستی ڕایی کردنی مامەڵەکان و بەناوکردنی لە بەڕێوەبەرایەتی تۆماری خانووبەرە بۆ لایەنی دووەم",
    arabic:
      "وكالة خاصة عند الكاتب العدل بالعقار المذكور لإجراء المعاملات و تسجيله بدائرة التسجيل العقاري للطرف الثاني.",
    english:
      "to complete propertied process to the second party in property registration directorate.",
  },
  {
    user_key: "nine_rule_one",
    kurdish: "لەسەر لایەنی یەکەم پێویستە دەسەڵات بدات بە پارێزەر ",
    arabic: "على الطرف الاول توكيل محامي",
    english: "The first party should authorize a solicitor",
  },
  {
    user_key: "lawyer",
    kurdish: "پارێزەر",
    arabic: "محامي",
    english: "lawyer",
  },
  {
    user_key: "six_rule_one",
    kurdish:
      "ئەگەر هاتوو هەر لایەنێک بە هەر هۆیەک پاشگەزبێتەوە لەم گرێبەستە دەبێت پابەند بێت بە پێدانی ",
    arabic: "اذا تنكل احد الطرفين عن العقد المبرم، على المتنكل دفع الغرامة",
    english: "If any of them regret to commit to the contract, the amount of",
  },
  {
    user_key: "six_rule_two",
    kurdish:
      "وەک پێبژاردن (غرامة) بە لایەنەکەی تر بەبێ ئاگادارکردنەوەی لایەنی فەرمی.",
    arabic: "للطرف الاخر بدون تبليغ رسمي",
    english:
      "must be paid as a penalty by one who will withdraw from the contract to another one without notifying interested party.",
  },
  {
    user_key: "note",
    kurdish: "تێبینی",
    arabic: "الملاحظات",
    english: "Note",
  },
  {
    user_key: "Most contract company",
    kurdish: "( ب-   دیڤاین  )",
    arabic: "منظم العقد/ دیڤاین ",
    english: "Contract organizer /Divine Real Estate Company",
  },
  {
    user_key: "Contract",
    kurdish: "گرێبەست",
    arabic: "العقد",
    english: "Contract",
  },
  {
    user_key: "Will the balance be made?",
    kurdish: "باڵانس دروست بێت",
    arabic: "سيتم تحقيق التوازن؟",
    english: "balance be made?",
  },
  {
    user_key: "Yes",
    kurdish: "بەڵێ",
    arabic: "نعم.",
    english: "Yes.",
  },
  {
    user_key: "No",
    kurdish: "نەخێر",
    arabic: "لا",
    english: "No",
  },
  {
    user_key: "Balance of Assurance",
    kurdish: "باڵانسی دڵنیایی",
    arabic: "ميزان الضمان",
    english: "Balance of Assurance",
  },
  /**
   * invoice list
   */
  {
    user_key: "Sell Contracts",
    kurdish: "لیستی گرێبەستی فرۆشتوو",
    arabic: "قائمة عقود البيع",
    english: "Sell Contracts",
  },
  {
    user_key: "Vellas List",
    kurdish: "لیستی ڤێلاکان",
    arabic: "قائمة فیلا",
    english: "List Vella",
  },
  {
    user_key: "Vella Contracts",
    kurdish: "لیستی گرێبەستی ڤێلا",
    arabic: "قائمة عقود فیلا",
    english: "Vella Contracts",
  },
  {
    user_key: "Sell_Contracts",
    kurdish: "گرێبەستی فرۆشتن",
    arabic: "عقود البيع",
    english: "Sell Contracts",
  },
  {
    user_key: "Sell_Contracts_purchoice",
    kurdish: "گرێبەستی کڕین",
    arabic: "عقود الشراء",
    english: "buying Contracts",
  },
  {
    user_key: "Contract List",
    kurdish: "لیستی گرێبەستەکان",
    arabic: "قائمة العقود",
    english: "Contract List",
  },
  {
    user_key: "Contract",
    kurdish: "گرێبەستەکان",
    arabic: "العقود",
    english: "Contracts",
  },
  {
    user_key: "Rent Contracts",
    kurdish: "لیستی گرێبەستە کرێیەکان",
    arabic: "قائمة عقود الإيجار",
    english: "Rent Contract List",
  },
  {
    user_key: "Rent_Contracts",
    kurdish: "گرێبەستی کرێ",
    arabic: "عقود الإيجار",
    english: "Rent Contract",
  },
  /// Rent Contract
  {
    user_key: "this",
    kurdish: "ئەم",
    arabic: "هذا",
    english: "this",
  },
  {
    user_key: "this__",
    kurdish: "ئەم",
    arabic: "أجرت ",
    english: "this",
  },
  {
    user_key: "to",
    kurdish: "تا",
    arabic: "ل",
    english: "to",
  },
  {
    user_key: "First side (property owner)",
    kurdish: "لایەنی یەکەم (خاوەن موڵك)",
    arabic: "الطرف الاول ( مالك)",
    english: "First party (property owner) :",
  },
  {
    user_key: "First Side",
    kurdish: "لایەنی یەکەم",
    arabic: "الطرف الأول",
    english: "First Party",
  },
  {
    user_key: "Second Side",
    kurdish: "لایەنی دووەم",
    arabic: "الطرف الثاني",
    english: "Second Party",
  },
  {
    user_key: "Second side (tenant)",
    kurdish: "لایەنی دووەم (کرێچی)",
    arabic: "الطرف الثاني ( المستأجر )",
    english: "Second party (tenant)",
  },
  {
    user_key: "I'm the first side to own this",
    kurdish: "من لایەنی یەکەم خاوەنی ئەم",
    arabic: " اني الطرف الاول صاحب",
    english: "I Am the first party the owner of",
  },
  {
    user_key: "rented to the second party on the date of",
    kurdish: "م بەکرێ داوە بە لایەنی دووەم لە ڕێکەوتی",
    arabic: " الى الطرف الثاني بتأريخ",
    english: "give it to the second party for rent in this date",
  },
  {
    user_key: "monthly wages",
    kurdish: "بە کرێی مانگانەی",
    arabic: " بإيجار شھري قدره",
    english: "date with monthly rent",
  },
  {
    user_key: "monthly payments",
    kurdish: "پارەی مانگانە",
    arabic: "مدفوعات شهرية",
    english: "Monthly Payments",
  },
  {
    user_key: "start date",
    kurdish: "بەرواری دەستپێکردن",
    arabic: "تاريخ البدء",
    english: "Start Date",
  },
  {
    user_key: "end date",
    kurdish: "بەرواری کۆتایی",
    arabic: "تاريخ الانتهاء",
    english: "End Date",
  },
  {
    user_key: "and by the amount_",
    kurdish: "وە بە بڕی",
    arabic: "وأستلمت مبلغ قدره",
    english: "and by the amount",
  },
  //
  {
    user_key: "as an introduction",
    kurdish: "وەکو پێشەکی",
    arabic: "كمقدمة",
    english: "down payment",
  },
  {
    user_key: "Posted",
    kurdish: "تۆمارکردن",
    arabic: "تسجيل",
    english: "Sign up",
  },
  {
    user_key: "I'm the second side of this",
    kurdish: "من لایەنی دووەم ئەم",
    arabic: "اني الطرف الثاني أستأجرت",
    english: "Iam second party I rent this",
  },
  {
    user_key: "I've hired him on the first side for a while",
    kurdish: "م بەکرێ گرتووە لە لایەنی یەکەم بۆ ماوەی",
    arabic: "مذكور أعلاه من طرف الاول لمدة",
    english: "I've hired him on the first side for a while",
  },
  {
    user_key: "and I'm doing it for purposes",
    kurdish: "وە بەکاری دێنم بۆ مەبەستی",
    arabic: "وأستخدمه لغرض",
    english: "and I use it for",
  },
  {
    user_key: "I'm doing it for purposes",
    kurdish: "بەکاری دێنم بۆ مەبەستی",
    arabic: "أفعل ذلك لأغراض",
    english: "I'm doing it for purposes",
  },
  {
    user_key: "for purposes",
    kurdish: "بۆ مەبەستی",
    arabic: "أفعل ذلك لأغراض",
    english: "for purposes",
  },
  {
    user_key: "Rent_agreement",
    kurdish: "من لایەنی دووەم پابەندم بە پێدانی کرێیەکە",
    arabic: " اني الطرف الثاني ألتزم بتسديد الايجار الشهري مقدماَ كل",
    english: "Iam second party I obliged to pay the rent",
  },
  {
    user_key: "once a preludant",
    kurdish: "مانگ جارێک پێشەکی",
    arabic: "كمقدمة",
    english: "once advance guard.",
  },
  {
    user_key: "The first side is committed to handing this over",
    kurdish: "لایەنی یەکەم پابەندە بە رادەستکردنی ئەم",
    arabic:
      " يلتزم الطرف الاول بتسليم (المأجور) الى الطرف الثاني دون أي نواقص بتأريخ",
    english: "The first party binding to surrender this",
  },
  {
    user_key: "without any shortcomings in the way",
    kurdish: "ە بەبێ هیچ کەم وکوڕیەک لە ڕیکەوتی",
    arabic: " الى الطرف الثاني دون اي نواقص بتأريخ",
    english: "to the second party without any shortage in agreement",
  },
  {
    user_key: "punshed",
    kurdish:
      "وەبە پێچەوانەوە دەبێت پێبژاردن(غرامە) بدات بە لایەنی دووەم بە بڕی",
    arabic: "وبعكسه يجب عليه دفع غرامة مالية بقيمة",
    english: "in reverse must pay fine to the second party with value of ",
  },
  {
    user_key: "For every day",
    kurdish:
      "بۆ هەر ڕۆژێک دواکەوتن بە کەمکردنەوەی ئەو بڕە پارەیە لە کرێی مانگانەی دیاریکراو.",
    arabic: "الى الطرف الثاني .",
    english: "for everyday delaying.",
  },
  {
    user_key: "month",
    kurdish: "مانگ",
    arabic: "أشهر",
    english: "Month",
  },
  {
    user_key: "fifth_rent",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی کرێیەکە لە ڕیکەوتی دیاریکراودا وە بە پێەچەوانەوە ئەگەر لە پێنج ڕۆژ زیاتر دواکەوت لە کاتی خۆی دەبێت پابەند بێت بە پێدانی پێبژاردنی (غرامة) بە لایەنی یەکەم بە بڕی ",
    arabic:
      "يلتزم الطرف الثاني بتسديد الايجار في موعدها الى الطرف الاول وعند تأخر في التسديد أكثر (5) من خمسة أيام يدفع غرامة مالية بقيمة",
    english:
      "Second party binding to give rent in specific date in reverse if its delayed for more than five days in its date must be binding to give fine to the first party with value of",
  },
  {
    user_key: "delays for each day except monthly fees",
    kurdish:
      "بۆ هەر رۆژێک دواکەوتن جگە لە کرێی مانگانە دەبێت ڕەزامەندبێت لەسەر کردنەوەی دەرگای موڵکەکە لەلایەن لایەنی یەکەم بە مەبەستی بە کرێدانەوەی،وە لایەنی دووەم بۆی نیە داوای هەر قەرەبوویەکی دارایی یان یاسایی بکات.",
    arabic:
      " الى الطرف الاول لكل يوم من التأخير عدا الايجار الشهري ويتم اخلاء الملك عن طريق الطرف الاول بدون الرجوع الى الطرف الثاني واعادة تأجير الملك اذا تأخر اكثر من شهر واحد .",
    english:
      "for each day delaying, the second party must be agreed for opening the estates door by the first party for the purpose of renting again.",
  },
  {
    user_key: "After the contract expires or when this is evacuated",
    kurdish: "پاش کۆتایی هاتنی ماوەی گرێبەستەکە یان لە کاتی چۆڵکردنی ئەم",
    arabic: "بعد انتھاء مدة العقد أو عند إخلاء ",
    english:
      "After the expiration of the contract or in the case of emptying this",
  },
  {
    user_key: "On the second side, this is necessary",
    kurdish: " ە لەسەر لایەنی دووەم پێویستە ئەم",
    arabic: "يجب على الطرف الثاني تسليم",
    english: "the party must be",
  },
  {
    user_key: "to give it to the first side without any shortcomings",
    kurdish: "ە رادەستی لایەنی یەکەم بکات بەبێ هیچ کەم و کوڕیەک",
    arabic: "الى الطرف الاول دون اي نواقص.",
    english: "surrender without any shortage.",
  },
  {
    user_key: "The second party is committed to paying the amount",
    kurdish: " لایەنی دووەم پابەندە بە پێدانی بڕی",
    arabic: "يلتزم الطرف الثاني دفع مبلغ قدره",
    english: "Second party binding to give the value of",
  },
  {
    user_key: "such as assurances",
    kurdish: "وەکو دڵنیایی(تآمینات) تاکۆتای هاتنی وادەی ئەم گرێبەستە.",
    arabic: "كتأمينات لغاية انتهاء مدة العقد.",
    english: "like insurance till to the end of this contract ,.",
  },
  {
    user_key: "such as Assurances",
    kurdish: "دڵنیایی(تآمینات)",
    arabic: "الضمانات",
    english: "such as assurances",
  },
  {
    user_key: "by the company",
    kurdish: " بە عقارات",
    arabic: "الى شركة",
    english: "to Company ",
  },
  {
    user_key: "Taj Emara Real Estate",
    kurdish: " دیڤاین ",
    arabic: "دیڤاین ",
    english: "Divine Real Estate ",
  },
  {
    user_key: "therteen_rent_two",
    kurdish: "لەبەرامبەر ڕێکخستنی ئەم گرێبەستە",
    arabic: "مقابل ترتيب هذا العقد",
    english: "In return for arranging this contract",
  },
  // {
  //   user_key: "17_rent_one",
  //   kurdish:
  //     "لایەنی دووەم پێش ڕادەستکردنی موڵکەکە پێویستە لەسەر ئەستۆی خۆی کلیلی دەرگا دەرەکیەکان بگۆڕێ ، بەپێچەوانەوە هەرکێشەیەک رووبدات خۆی بەرپرسیارە",
  //   arabic:
  //     "من الضروري على الجانب الثاني قبل شهر من مغادرة أو نهاية عقد المالك والشركة",
  //   english:
  //     "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  // },
  {
    user_key: "6_rent_one",
    kurdish:
      "هەردوو لایەن پابەندن بە پێدانی کرێی نیو مانگ بۆ   عقارات دیڤاین  لە بەرامبەر ڕێکخستنی ئەم گرێبەستە.",
    arabic: "عند انتهاء مدة العقد أو الاخلاء على الطرف الثاني تسليم",
    english:
      "Both parties binding to give half month rent to Homle Real Estate Company against organizing this contract.",
  },
  {
    user_key: "6_rent_one___",
    kurdish:
      "هەردوو لایەن پابەندن بە پێدانی کرێی نیو مانگ بۆ   عقارات دیڤاین  لە بەرامبەر ڕێکخستنی ئەم گرێبەستە.",
    arabic: "من دون نواقص.",
    english:
      "Both parties binding to give half month rent to Homle Real Estate Company against organizing this contract.",
  },
  {
    user_key: "6_rent_two",
    kurdish:
      "هەردوو لایەن پابەندن بە پێدانی کرێی نیو مانگ بۆ   عقارات دیڤاین  لە بەرامبەر ڕێکخستنی ئەم گرێبەستە.",
    arabic: "الطرف الاول دون أي نواقص .",
    english:
      "Both parties binding to give half month rent to Homle Real Estate Company against organizing this contract.",
  },
  {
    user_key: "14_rent_one",
    kurdish:
      "هەردوو لایەن پابەندن بە پێدانی کرێی نیو مانگ بۆ   عقارات دیڤاین  لە بەرامبەر ڕێکخستنی ئەم گرێبەستە.",
    arabic:
      "يلتزم الطرفان بدفع أيجار نصف الشهر الى شركة ( سیساوە  ) مقابل تنظيمها للعقد وفي حالة نكول أي من الطرفين العقد فأن الشركة المذكوره غير ملزمة بأعادة المبلغ المذكور.",
    english:
      "Both parties binding to give half month rent to Homle Real Estate Company against organizing this contract.",
  },
  {
    user_key: "15_rent_one",
    kurdish:
      "لەکاتی بوونی هەرکێشەیەک لەم گرێبەستەدا، دادگای هەولێر کێشەکە یەکلایی دەکاتەوە.",
    arabic:
      "لايجوز للمستأجر المطالبة بمفاتيح المأجور الا بعد حصوله على موافقة ( اسايش أربيل ) وأطراف معنيه أخرى.",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  {
    user_key: "16_rent_one",
    kurdish:
      "لەکاتی فرۆشتنی ئەم موڵکە خاوەنی نوێ دەبێ پابەند بێت بەناوەڕۆکی ئەم گرێبەستە",
    arabic:
      "على المستأجر قبل الانتفاع للمأجور تبديل قفل الباب الرئيسي وبعكسه فأنه يتحمل نتائج عدم قيامه بذلك.",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  {
    user_key: "17_rent_one",
    kurdish:
      "لەکاتی فرۆشتنی ئەم موڵکە خاوەنی نوێ دەبێ پابەند بێت بەناوەڕۆکی ئەم گرێبەستە",
    arabic: "لايجوز لمالك العقار المطالبه بأخلاء قبل قضاء مدة العقد .",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  {
    user_key: "18_rent_one",
    kurdish:
      "لەکاتی فرۆشتنی ئەم موڵکە خاوەنی نوێ دەبێ پابەند بێت بەناوەڕۆکی ئەم گرێبەستە",
    arabic:
      "في حالة حدوث الكوارث الطبيعية أو حريقاً أو حوادث غير متوقعة في المأجور فأن شركة ( سیساوە  ) غير مسؤوله عن تلك الحوادث.",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  {
    user_key: "19_rent_one",
    kurdish:
      "لەکاتی فرۆشتنی ئەم موڵکە خاوەنی نوێ دەبێ پابەند بێت بەناوەڕۆکی ئەم گرێبەستە",
    arabic:
      "في حالة حدوث نزاع بين أطراف العقد تكون المحكمة (اربیل)  هي المختصه في البت بذلك.",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  /**
   * Psulay parawargrtn wasl
   */
  {
    user_key: "taking_money",
    kurdish: "پارەوەرگرتنەکان",
    arabic: "أخذ المال.",
    english: "taking money",
  },
  {
    user_key: "taking money",
    kurdish: "پارەوەرگرتن",
    arabic: "أخذ المال.",
    english: "taking money",
  },
  {
    user_key: "list taking money",
    kurdish: "لیستی پارەوەرگرتن",
    arabic: "قائمة أستلام",
    english: "List of taking money",
  },
  {
    user_key: "Repayment bills",
    kurdish: "پسوولەی پارەوەرگرتن",
    arabic: "فواتير الإستلام",
    english: "Repayment bills",
  },
  {
    user_key: "Payment bills",
    kurdish: "پسوولەی پارەدان",
    arabic: "فواتير الدفع",
    english: "Payment bills",
  },
  {
    user_key: "Repayment",
    kurdish: "پارەوەرگرتن",
    arabic: "الإستلام",
    english: "Repayment",
  },
  {
    user_key: "Monthly rent invoice",
    kurdish: "کرێی مانگانە",
    arabic: "فواتير الإيجار الشهري",
    english: "Monthly rent invoice",
  },
  {
    user_key: "Service Bill",
    kurdish: "خزمەتگوزاری",
    arabic: "فواتير الخدمات",
    english: "Service Bill",
  },
  {
    user_key: "Insurance Bill",
    kurdish: "دڵنیایی",
    arabic: "التأمين",
    english: "Insurance Bill",
  },
  {
    user_key: "Instead of",
    kurdish: "لە بری",
    arabic: "بدلاً من",
    english: "Instead of",
  },
  {
    user_key: "money",
    kurdish: "بڕی پارە",
    arabic: "المبلغ",
    english: "Amount",
  },
  {
    user_key: "received from Mr",
    kurdish: "وەرگیرا لە بەڕێز",
    arabic: "وردت من السيد",
    english: "Received From Mr",
  },
  {
    user_key: "representer",
    kurdish: "ناوی نوێنەر",
    arabic: "اسم الممثل",
    english: "Representer",
  },
  {
    user_key: "Company Branch",
    kurdish: "لقی  عقارات",
    arabic: "فرع الشركة",
    english: "Branch",
  },
  {
    user_key: "Lease date",
    kurdish: "ڕێکەوتی بەکرێدان",
    arabic: "تاريخ التأجير",
    english: "rent date",
  },
  {
    user_key: "end of the lease",
    kurdish: "ڕێکەوتی کۆتایی کرێ",
    arabic: "تاريخ انتهاء عقد الإيجار",
    english: "end of the renting",
  },
  {
    user_key: "Payer Signature",
    kurdish: "ئیمزای پارەدەر",
    arabic: "توقيع المشتري",
    english: "buyer Signature",
  },
  {
    user_key: "Name of the recipient",
    kurdish: "ناوی پارە وەرگر",
    arabic: "اسم المستلم",
    english: "Name of the recipient",
  },
  {
    user_key: "Recipient's signature seal",
    kurdish: "ئیمزای وەرگر",
    arabic: "توقيع المستلم",
    english: "Recipient's signature",
  },
  {
    user_key: "dolar",
    kurdish: "دۆلار",
    arabic: "دولار",
    english: "dolar",
  },
  {
    user_key: "Witness",
    kurdish: "شاهێد",
    arabic: "شاهد",
    english: "Witness",
  },
  {
    user_key: "dinar",
    kurdish: "دینار",
    arabic: "دینار",
    english: "dinar",
  },
  {
    user_key: "no records",
    kurdish: "هیچ تۆمارێک نییە بۆ پیشاندانی",
    arabic: "لا توجد ملفات لعرضها",
    english: "there are no files to display",
  },
  {
    user_key: "Currency Type",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "Currency",
  },
  //
  {
    user_key: "one tenant's contract",
    kurdish: "گرێبەستی یەک کرێچی",
    arabic: "عقد مستأجر واحد",
    english: "One Tenant's Contract",
  },
  {
    user_key: "one tenant's bill",
    kurdish: "پسوولەی یەک کرێچی",
    arabic: "فاتورة مستأجر واحد",
    english: "One Tenant's Bill",
  },
  {
    user_key: "Currency Type",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "Currency Type",
  },
  // dashboard
  {
    user_key: "newest sell contract",
    kurdish: "نوێترین گرێبەستی فرۆشتن",
    arabic: "أحدث عقد بيع",
    english: "Newest Sell Contract",
  },
  {
    user_key: "newest rent contract",
    kurdish: "نوێترین گرێبەستی کرێ",
    arabic: "أحدث عقد إيجار",
    english: "Newest Rent Contract",
  },
  {
    user_key: "The latest bill to receive money",
    kurdish: "تازەترین پسوڵەی پارەوەرگرتن",
    arabic: "آخر فاتورة سداد",
    english: "latest payment bill",
  },
  {
    user_key: "Newest Sale Property",
    kurdish: "نوێترین موڵکی فرۆشتن",
    arabic: "أحدث عقار للبيع",
    english: "Newest Sale Property",
  },
  {
    user_key: "The newest rental property",
    kurdish: "نوێترین موڵکی کرێ",
    arabic: "أحدث عقار للإيجار",
    english: "The newest rental property",
  },
  {
    user_key: "Number of properties",
    kurdish: "ژمارەی موڵکەکان",
    arabic: "عدد العقارات",
    english: "Numbers of Properties",
  },
  {
    user_key: "Number of property",
    kurdish: "ژمارەی موڵک",
    arabic: "رقم العقار",
    english: "Number of Property",
  },
  {
    user_key: "Total Sales",
    kurdish: "کۆی فرۆشتنەکان",
    arabic: "إجمالي المبيعات",
    english: "Total Sales",
  },
  // raports
  {
    user_key: "start_d",
    kurdish: "بەرواری سەرەتا",
    arabic: "تاريخ البدء ",
    english: "Start Date",
  },
  {
    user_key: "end_d",
    kurdish: "بەرواری کۆتا",
    arabic: "تاريخ الانتهاء ",
    english: "End Date",
  },
  {
    user_key: "search_d",
    kurdish: "گەڕان بە پێی ڕۆژ",
    arabic: "البحث باليوم",
    english: "Search By Date",
  },
  {
    user_key: "weekly_report",
    kurdish: "ڕاپۆرتی هەفتانە",
    arabic: "تقرير أسبوعي",
    english: "Weekly Report",
  },
  {
    user_key: "s_reports",
    kurdish: "راپۆرتەکان",
    arabic: "التقارير",
    english: "Reports",
  },
  {
    user_key: "search_m",
    kurdish: "گەڕان بە پێی مانگ",
    arabic: "البحث بالشهر",
    english: "Search By Month",
  },
  {
    user_key: "Earth",
    kurdish: "زەوی",
    arabic: "أرض",
    english: "Earth",
  },
  {
    user_key: "search_y",
    kurdish: "گەڕان بە پێی ساڵ",
    arabic: "البحث بالسنة",
    english: "Search By Year",
  },
  {
    user_key: "Completion rental contract",
    kurdish: "تەواوبونی گرێبەستی کرێ",
    arabic: "إنتهاء عقد الإيجار",
    english: "end of rent contract",
  },
  {
    user_key: "Rental contract report",
    kurdish: "ڕاپۆرتی گرێبەستی کرێ",
    arabic: "تقرير عقد الإيجار",
    english: "Rental contract report",
  },
  {
    user_key: "Sales Contract Report",
    kurdish: "ڕاپۆرتی گرێبەستی فرۆشتن",
    arabic: "تقرير عقد البيع",
    english: "Sales Contract Report",
  },
  {
    user_key: "Property Report",
    kurdish: "ڕاپۆرتی موڵکەکان",
    arabic: "تقرير العقار",
    english: "Property Report",
  },
  {
    user_key: "Property Required Report",
    kurdish: "ڕاپۆرتی داواکاری موڵك",
    arabic: "تقرير الطلب العقار",
    english: "Property Required Report",
  },
  {
    user_key: "MY TO DO LIST",
    kurdish: "ئەوکارانەی پێووستە ئەنجامی بدەم",
    arabic: "قائمة المهام",
    english: "MY TO DO LIST",
  },
  {
    user_key: "comision",
    kurdish: "عمولە",
    arabic: "عمولة",
    english: "comision",
  },
  {
    user_key: "investor",
    kurdish: "پسوولەی دەرەکی",
    arabic: "الإيصالات الخارجية",
    english: "External receipts",
  },
  /// masrufat
  {
    user_key: "Expenses",
    kurdish: "خەرجیەکان",
    arabic: "وصولات",
    english: "Expenses",
  },
  {
    user_key: "Cost type",
    kurdish: "جۆری خەرجی",
    arabic: "نوع المصروفات",
    english: "Cost type",
  },
  {
    user_key: "Total money.",
    kurdish: "کۆی پارە",
    arabic: "المبلغ الكلي",
    english: "Total money.",
  },
  {
    user_key: "Total money $",
    kurdish: "کۆی پارە بە $",
    arabic: "$ مجموع المال",
    english: "Total money $",
  },
  {
    user_key: "Total money ID",
    kurdish: "کۆی پارە بە ID",
    arabic: "المبلغ الكلي ID",
    english: "Total money ID",
  },
  {
    user_key: "Expenses List",
    kurdish: "لیستی خەرجییەکان",
    arabic: "قائمة وصولات",
    english: "Expenses List",
  },
  {
    user_key: "Amount of money",
    kurdish: "بڕی پارە",
    arabic: "المبلغ",
    english: "Amount of money",
  },
  {
    user_key: "Profit",
    kurdish: "قازانج",
    arabic: "فوائد",
    english: "Benefits",
  },
  {
    user_key: "AgentـDetail",
    kurdish: "وردەکاری وەکیل",
    arabic: "تفاصيل الوكيل",
    english: "Agent Detail",
  },
  {
    user_key: "table_display",
    kurdish: "هیچ تۆمارکردنێک نیە",
    arabic: "لا توجد ملفات لعرضها",
    english: "There is no record to display",
  },
  {
    user_key: "Main Form",
    kurdish: "فۆڕمی سەرەکی",
    arabic: "نموذج اول",
    english: "Main Form",
  },
  {
    user_key: "Secondary Form",
    kurdish: "فۆڕمی لاوەکی",
    arabic: "نموذج ثاني",
    english: "Secondary Form",
  },
  {
    user_key: "Choose the type of rental contract",
    kurdish: "شێوازی جۆری گرێبەستی کرێ هەڵبژێرە",
    arabic: "اختر نوع عقد الإيجار",
    english: "Choose the type of rental contract",
  },
  {
    user_key: "On the date of",
    kurdish: "لە ڕێکەوتی",
    arabic: "من تاريخ",
    english: "On the date of",
  },
  {
    user_key: "For a date",
    kurdish: "بۆ ڕێکەوتی",
    arabic: " حتى تاريخ",
    english: "For a date",
  },
  {
    user_key: "Rental period",
    kurdish: "ماوەی بەکرێدان",
    arabic: "مدة الإيجار",
    english: "Rental period",
  },
  {
    user_key: "Date of surrender",
    kurdish: "ڕێکەوتی ڕێپێدان",
    arabic: "تاريخ الاستلام",
    english: "Date of surrender",
  },
  {
    user_key: "amount of money in advance",
    kurdish: "بڕی پارە پێشەکی",
    arabic: "العربون",
    english: "Amount of Money in Advance",
  },
  {
    user_key: "Amount of punishment",
    kurdish: "بڕی سزای دواکەوتن",
    arabic: "غرامة التأخير",
    english: "Amount of punishment",
  },
  {
    user_key: "Choose the type of sales contract",
    kurdish: "شێوازی جۆری گرێبەستی فرۆشتن هەڵبژێرە",
    arabic: "اختر نوع عقد البيع",
    english: "Choose the type of sales contract",
  },
  {
    user_key: "Payment date",
    kurdish: "ڕێکەوتی پارەدان",
    arabic: "تاريخ الدفع",
    english: "Payment date",
  },
  {
    user_key: "Bills",
    kurdish: "پسوولەکان",
    arabic: "فواتير",
    english: "Bills",
  },
  {
    user_key: "normal_agent",
    kurdish: "کارمەندی ئاسایی",
    arabic: "موظف عادي",
    english: "Regular Employee",
  },
  {
    user_key: "Payment",
    kurdish: "پارەپێدان",
    arabic: "الدفع",
    english: "Payment",
  },
  {
    user_key: "Choose the type of payment or payment bill type",
    kurdish: "شێوازی جۆری پسوولەی پارەدان یان پارەوەرگرتن هەڵبژێرە",
    arabic: "اختر طريقة الدفع أو نوع فاتورة الدفع",
    english: "Choose the type of payment or payment bill type",
  },
  {
    user_key: "Choose a security or customer's ankit type style",
    kurdish: "شێوازی جۆری ئەنکێتی ئاسایش یان کڕیار هەڵبژێرە",
    arabic: "اختر نمط نوع الأمان أو نوع ankit الخاص بالعميل",
    english: "Choose a security or customer's ankit type style",
  },
  {
    user_key: "such as",
    kurdish: "وەکو",
    arabic: "مثل",
    english: "such as",
  },
  {
    user_key: "such_as",
    kurdish: "وەک",
    arabic: "ملاحظه",
    english: "such as",
  },
  {
    user_key: "Number of bills",
    kurdish: "ژمارەی پسوولە",
    arabic: "رقم الفاتورة",
    english: "Number of bills",
  },
  {
    user_key: "Security Bill",
    kurdish: "پسوولەی ئاسایش",
    arabic: "موافقة الأسايش",
    english: "security Bill",
  },
  {
    user_key: "to the security base",
    kurdish: "بۆ بنکەی ئاسایشی",
    arabic: "لمقر الأسايش",
    english: "to the security base",
  },
  {
    user_key: "security base",
    kurdish: "بنکەی ئاسایشی",
    arabic: "مقر الأسايش",
    english: "Security Base",
  },
  {
    user_key: "Company Name",
    kurdish: "ناوی کۆمپانیای عقارات",
    arabic: "اسم الشركة",
    english: "Company Name",
  },
  {
    user_key: "Company mobile number",
    kurdish: "ژمارەی مۆبایلی  عقارات",
    arabic: "هاتف الشركة",
    english: "Company mobile number",
  },
  {
    user_key: "The name of the tenant",
    kurdish: "ناوی کرێچی",
    arabic: "اسم المستأجر",
    english: "Tenant Name",
  },
  {
    user_key: "where they came",
    kurdish: "شوێنی هاتن",
    arabic: "عنوان قديم",
    english: "where they came",
  },
  {
    user_key: "The name of the neighborhood",
    kurdish: "ناوی گەڕەک",
    arabic: "اسم المنطقة",
    english: "Alley Name",
  },
  {
    user_key: "Seating",
    kurdish: "شوێنی دانیشتن",
    arabic: "عنوان السكن",
    english: "Seating",
  },
  {
    user_key: "We're like",
    kurdish: "ئێمە وەکــو ",
    arabic: "نحن مثل",
    english: "We're like ",
  },
  {
    user_key: `asawesh`,
    kurdish: `.پابەندیــن بە گشت یاسا و ڕینمایەکانــی لایەنیـی پەیوەنـدی دار "ئاسایش"، و دوور دەبیــن لە کاری نا یاسایی`,
    arabic: `.نحن نلتزم بجميع القوانين واللوائح المتعلقة بشجرة "الأمن"، ونتجنب الأعمال غير القانونية`,
    english: `We abide by all laws and regulations related to the "security" tree, and avoid illegal acts.`,
  },
  {
    user_key: "fee",
    kurdish: "وەکو پێبژاردن (غرامة).",
    arabic: " غرامة",
    english: "as a penalty",
  },
  {
    user_key: "paray_mawa",
    kurdish: "پێویستە بدرێت لە ڕێكەوتی ",
    arabic: "يتم الدفع بتاريخ",
    english: "paray_mawa",
  },
  {
    user_key: "recive_money",
    kurdish: "پارەی ماوە",
    arabic: "مقدار الثني",
    english: "Money left",
  },
  {
    user_key: "payment date left",
    kurdish: "کاتی پارەدانی ماوە",
    arabic: "تاريخ دفع متبقي",
    english: "payment date left",
  },
  {
    user_key: "imageUrl",
    kurdish: "وێنە",
    arabic: "صورة",
    english: "Image",
  },
  {
    user_key: "NumberOfShuqa",
    kurdish: "ژمارەی شوقە",
    arabic: "رقم شوقة",
    english: "Apartment No",
  },
  {
    user_key: "block",
    kurdish: "بینایە",
    arabic: "عماره",
    english: "Block",
  },
  {
    user_key: "Amount of dissuade",
    kurdish: "بڕی پاشگەزبوونەوە",
    arabic: "غرامة التراجع",
    english: "Amount of dissuade",
  },
  {
    user_key: "Lawyer's name",
    kurdish: "ناوی پارێزەر",
    arabic: "اسم المحامي",
    english: "Lawyer's name",
  },
  {
    user_key: "and by the amount",
    kurdish: "وە بڕی",
    arabic: "و بالمبلغ",
    english: "and by the amount.",
  },
  {
    user_key: "as introduction for month",
    kurdish: "وەردەگرم وەک پێشەکی",
    arabic: "كمقدمة",
    english: "I take as an down payment",
  },
  {
    user_key: "as introduction for Month",
    kurdish: "وەک پێشەکی",
    arabic: "مقدمة ",
    english: "as introduction",
  },
  {
    user_key: "new_ten_rule",
    kurdish:
      "ناکرێت واز لەم ڕێکەوتننامەیە بهێنرێت (یاخود دەستی لێهەڵبگیرێت) لە بەشێک یان هەموو بەشەکانی ئەم گرێبەستە بۆ کرێدارێکی تر یاخود هەر کەسێکی تر بەبێ ڕەزامەندی خاوەنەکەی.",
    arabic:
      "لا يمكن للجانب الآخر إجراء أي تغييرات داخل وخارج هذه الخاصية دون موافقة مالك العقار",
    english:
      "The other side cannot make any changes inside and outside this property without the consent of the owner of the property",
  },
  {
    user_key: "once a month in advance",
    kurdish: "مانگ جارێک پێشەکی",
    arabic: "مرة واحدة في الشهر مقدما",
    english: "once a month in advance",
  },
  {
    user_key: "Print",
    kurdish: "چاپکردن",
    arabic: "طباعة",
    english: "Print",
  },
  {
    user_key: "Security Bill List",
    kurdish: "لیستی پسوولەی ئاسایش",
    arabic: "قائمة فواتير الأسايش",
    english: "Security Bill List",
  },
  {
    user_key: "List of Bills",
    kurdish: "لیستی پسوولەکان",
    arabic: "قائمة الفواتير",
    english: "List of Bills",
  },
  {
    user_key: "Payments List",
    kurdish: "لیستی پارەپێدانەکان",
    arabic: "قائمة المدفوعات",
    english: "Payments List",
  },
  {
    user_key: "Please Check Inputs",
    kurdish: "تکایە خانەکان پڕبکەوە",
    arabic: "الرجاء تعبئة الخانات",
    english: "Please Check Inputs",
  },
  {
    user_key: "Ok",
    kurdish: "باشە",
    arabic: "جید",
    english: "Ok",
  },
  {
    user_key: "Are you sure",
    kurdish: "?ئایا دڵنیایت",
    arabic: "?هل أنت متأكد",
    english: "Are you sure?",
  },
  {
    user_key: "You won't be able to delete this!",
    kurdish: "دەتەوێ بیسڕیتەوە",
    arabic: "تريد حذفه",
    english: "You want to delete it.!",
  },
  {
    user_key: "Yes, delete it",
    kurdish: "بەڵێ، بسڕەوە.",
    arabic: "نعم، احذفه",
    english: "Yes, delete it",
  },
  {
    user_key: "Add_delete",
    kurdish: "سڕینەوە",
    arabic: "مسح تعلیق",
    english: "Delete",
  },
  {
    user_key: "Delete",
    kurdish: "سڕایەوە",
    arabic: "محذوف",
    english: "Delete",
  },
  {
    user_key: "success",
    kurdish: "سەرکەوتووبوو",
    arabic: "ناجحا",
    english: "success",
  },
  {
    user_key: "You successfully tainted your work",
    kurdish: "کارەکەت بە سەرکەوتوویی تاواوکرد.",
    arabic: "لقد نجحت في تلويث عملك",
    english: "You successfully tainted your work",
  },
  {
    user_key: "Taken from",
    kurdish: "لێوەرگیراو",
    arabic: "مأخوذة من",
    english: "Taken from",
  },
  {
    user_key: "given",
    kurdish: "پێــــدراو",
    arabic: "نظرا",
    english: "Given",
  },
  {
    user_key: "It was given to sir",
    kurdish: "درا بە بەڕێز",
    arabic: "لقد أعطيت إلى سيد",
    english: "It was given to sir",
  },
  {
    user_key: "Sceurity Anket",
    kurdish: "ئەنکێتی ئاسایش",
    arabic: "موافقة الأسايش",
    english: "Security Anket",
  },
  {
    user_key: "Sceurity_Anket",
    kurdish: "لیستی ئاسایش",
    arabic: "قائمة الأسايش",
    english: "Sceurity Anket",
  },
  {
    user_key: "Rebaru_seven",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی ( کرێی یەک مانگ) بە   عقارات عقارات هۆمیڵی وەکوو دڵنیای (تآمینات) تا کۆتایی هاتنی وادەی ئەم گرێبەستە.",
    arabic:
      "لایەنی دووەم پابەندە بە پێدانی ( کرێی یەک مانگ) بە   عقارات عقارات هۆمیڵی وەکوو دڵنیای (تآمینات) تا کۆتایی هاتنی وادەی ئەم گرێبەستە.",
    english:
      "لایەنی دووەم پابەندە بە پێدانی ( کرێی یەک مانگ) بە   عقارات عقارات هۆمیڵی وەکوو دڵنیای (تآمینات) تا کۆتایی هاتنی وادەی ئەم گرێبەستە.",
  },
  {
    user_key: "company_money",
    kurdish: "بڕی پارە بۆ  عقارات",
    arabic: "مبلغ للشركة",
    english: "Amount of Company",
  },
  {
    user_key: "Punishment after five days",
    kurdish: "سزا دوای هەر ڕۆژێک",
    arabic: "العقاب بعد كل يوم",
    english: "Punishment after each day",
  },
  {
    user_key: "Update Profile",
    kurdish: "دەستکاری لاپەڕەی کەسی",
    arabic: "تعديل الملف الشخصي",
    english: "Update Profile",
  },
  {
    user_key: "Contracts sold",
    kurdish: "گرێبەستە فرۆشتووەکان",
    arabic: "عقود البيع",
    english: "sell Contracts",
  },
  {
    user_key: "Rental Contracts",
    kurdish: "گرێبەستە کرێیەکان",
    arabic: "عقود الإيجار",
    english: "Rental Contracts",
  },
  {
    user_key: "Sold",
    kurdish: "فرۆشراو",
    arabic: "مباع",
    english: "Sold",
  },
  {
    user_key: "Unsold",
    kurdish: "نەفرۆشراو",
    arabic: "غير مباع",
    english: "Unsold",
  },
  {
    user_key: "Rented",
    kurdish: "بەکرێدراو",
    arabic: "مؤجر",
    english: "Rented",
  },
  {
    user_key: "Activities",
    kurdish: "چاڵاکەکان",
    arabic: "المتاحة",
    english: "Activities",
  },
  {
    user_key: "purpose",
    kurdish: "مەبەست",
    arabic: "مقترح",
    english: "Purpose",
  },
  {
    user_key: "Number of Months",
    kurdish: "ژمارەی مانگەکان",
    arabic: "عدد الشهور",
    english: "Number of Months",
  },
  {
    user_key: "monthly payments",
    kurdish: "پارەی مانگانە",
    arabic: "دفعات شهرية",
    english: "Monthly Payments",
  },
  {
    user_key: "Project_List",
    kurdish: "لیستی پڕۆژەکان",
    arabic: "قائمة المشاريع",
    english: "List Projects",
  },
  {
    user_key: "MetrPrice",
    kurdish: "نرخی مەتر",
    arabic: "سعر المتر",
    english: "MetrPrice",
  },
  {
    user_key: "totalBase",
    kurdish: "کۆی گشتی",
    arabic: "المجموع الكلي",
    english: "totalBase",
  },
  {
    user_key: "Project Name",
    kurdish: "ناوی پرۆژە",
    arabic: "اسم المشروع",
    english: "Project Name ",
  },
  {
    user_key: "TIP",
    kurdish: "تایپ",
    arabic: "تایب",
    english: "TIP",
  },
  {
    user_key: "Show Password",
    kurdish: "پیشاندانی پاسۆرد",
    arabic: "إظهار كلمة المرور",
    english: "Show Password",
  },
  {
    user_key: "flour",
    kurdish: "قاتی",
    arabic: "طابق",
    english: "Floor",
  },
  {
    user_key: "for the project",
    kurdish: "بۆ پڕۆژەی",
    arabic: "للمشروع",
    english: "For the Project",
  },
  {
    user_key: "Project Anket",
    kurdish: "ئەنکێتی خزمەتگوزاری پڕۆژە",
    arabic: "ئەنکێتی خزمەتگوزاری پڕۆژە",
    english: "Project Anket",
  },
  {
    user_key: "diffrence",
    kurdish: "جیاوازی",
    arabic: "الفروقات",
    english: "difference",
  },
  {
    user_key: "MonthlyShortPay",
    kurdish: "قستی مانگانە",
    arabic: "القسط الشهري",
    english: "MonthlyShortPay",
  },
  {
    user_key: "Support",
    kurdish: "پشتگیری",
    arabic: "تءيد",
    english: "Support",
  },
  {
    user_key: "hold",
    kurdish: "گرتراوە",
    arabic: "حجز",
    english: "Hold",
  },
  {
    user_key: "Installment",
    kurdish: "قست",
    arabic: "الآقساط",
    english: "Installment",
  },
  {
    user_key: "salePerMetr",
    kurdish: "نرخی بازاڕ",
    arabic: "سعر السوق",
    english: "salePerMetr",
  },
  {
    user_key: "total",
    kurdish: "کۆی گشتی",
    arabic: "المجموع",
    english: "total",
  },
  {
    user_key: "NumberMonth",
    kurdish: "ژمارەی مانگەکان",
    arabic: "عدد الشهور",
    english: "NumberMonth",
  },
  {
    user_key: "language",
    kurdish: "زمان",
    arabic: "اللغة",
    english: "Language",
  },
  {
    user_key: "Side",
    kurdish: "ڕوو",
    arabic: "جانب",
    english: "Side",
  },
  {
    user_key: "imageUrl",
    kurdish: "وێنە",
    arabic: "صورة",
    english: "imageUrl",
  },
  {
    user_key: "Updating Apartment",
    kurdish: "نوێکردنەوەی شوقە",
    arabic: "تجديد الشقة",
    english: "Updating Apartment",
  },
  {
    user_key: "Approve",
    kurdish: "پەسەندکردن",
    arabic: "موافقة",
    english: "Approve",
  },
  {
    user_key: "Approved",
    kurdish: "پەسندکراوە",
    arabic: "تمت الموافقة",
    english: "Approved",
  },
  {
    user_key: "Show",
    kurdish: "پیشاندان",
    arabic: "عرض",
    english: "Show",
  },
  {
    user_key: "بیست",
    kurdish: "بیست",
    arabic: "عشرون",
    english: "20",
  },
  {
    user_key: "پازدەم",
    kurdish: "پازدەم",
    arabic: "خمسة عشر",
    english: "15",
  },
  {
    user_key: "شازدەم",
    kurdish: "شازدەم",
    arabic: "ستة عشر",
    english: "16",
  },
  {
    user_key: "حەڤدەم",
    kurdish: "حەڤدەم",
    arabic: "سابع عشر",
    english: "17",
  },
  {
    user_key: "نۆزدەم",
    kurdish: "نۆزدەم",
    arabic: "التاسع عشر",
    english: "19",
  },
  {
    user_key: "هەژدەم",
    kurdish: "هەژدەم",
    arabic: "ثامن عشر",
    english: "18",
  },
  {
    user_key: "چواردەم",
    kurdish: "چواردەم",
    arabic: "الرابع عشر",
    english: "14",
  },
  {
    user_key: "سیانزەم",
    kurdish: "سیانزەم",
    arabic: "الثالث عشر",
    english: "13",
  },
  {
    user_key: "دوانزەم",
    kurdish: "دوانزەم",
    arabic: "الثاني عشر",
    english: "12",
  },
  {
    user_key: "یانزەم",
    kurdish: "یانزەم",
    arabic: "الحادي عشر",
    english: "11",
  },
  {
    user_key: "دەیەم",
    kurdish: "دەیەم",
    arabic: "العاشر",
    english: "10",
  },
  {
    user_key: "نۆیەم",
    kurdish: "نۆیەم",
    arabic: "التاسع",
    english: "9",
  },
  {
    user_key: "هەشتەم",
    kurdish: "هەشتەم",
    arabic: "الثامن",
    english: "8",
  },
  {
    user_key: "حەوتەم",
    kurdish: "حەوتەم",
    arabic: "السابع",
    english: "7",
  },
  {
    user_key: "شەشەم",
    kurdish: "شەشەم",
    arabic: "السادس",
    english: "6",
  },
  {
    user_key: "پێنجەم",
    kurdish: "پێنجەم",
    arabic: "الخامس",
    english: "5",
  },
  {
    user_key: "چوارەم",
    kurdish: "چوارەم",
    arabic: "الرابع",
    english: "4",
  },
  {
    user_key: "سێیەم",
    kurdish: "سێیەم",
    arabic: "الثالث",
    english: "3",
  },
  {
    user_key: "دووەم",
    kurdish: "دووەم",
    arabic: "الثاني",
    english: "2",
  },
  {
    user_key: "یەکەم",
    kurdish: "یەکەم",
    arabic: "الأول",
    english: "1",
  },
  {
    user_key: "Today is the time of Mr. Monthly Wage",
    kurdish: "ئەمرۆ کاتی کرێی مانگانەی بەڕێز ",
    arabic: "اليوم هو وقت السيد الأجر الشهري",
    english: "Today is the time of Mr. Monthly Wage",
  },
  {
    user_key: "Today time to the end of contract of",
    kurdish: "گڕێبەستی ئەم بەڕێزە کۆتایی هات",
    arabic: "اليوم هو وقت نهاىة عقد السيد",
    english: "Today time to the end of contract of",
  },
  {
    user_key: "New Contract",
    kurdish: "گرێبەستی نوێ",
    arabic: "عقد جديد",
    english: "New Contract",
  },
  {
    user_key: "Balance",
    kurdish: "باڵانس",
    arabic: "رصيد",
    english: "Balance",
  },
  {
    user_key: "Old Balance",
    kurdish: "باڵانسی کۆن",
    arabic: "رصيد قديم",
    english: "Old Balance",
  },
  {
    user_key: "New Balance",
    kurdish: "باڵانسی نوێ",
    arabic: "رصيد جديد",
    english: "New Balance",
  },
  {
    user_key: "Action",
    kurdish: "کردارەکان",
    arabic: "افعال",
    english: "Action",
  },
  {
    user_key: "Tenants_",
    kurdish: "کرێچیەکان",
    arabic: "المستأجرين",
    english: "Tenants",
  },
  {
    user_key: "Permission date",
    kurdish: "ڕێکەوتی ڕێپێدان",
    arabic: "تاريخ الإذن",
    english: "Permission date",
  },

  /**
   * balav Rent Translation
   */

  {
    user_key: "balav_1_1",
    kurdish:
      "لایەنی یەکەم ڕەزامەندە لەسەر بەکرێدانی ئەم موڵکە کەلە سەرەوە ئاماژەی پێکراوە بەلانی دووەم.",
    arabic:
      "وافق الطرف الأول على تأجير هذا العقار المذكور أعلاه إلى الطرف الثاني. ",
    english:
      "The first party agrees to lease the property which is referred to above to the second party.",
  },
  {
    user_key: "balav_2_1",
    kurdish: "ماوەی ئەم گریبەستە",
    arabic: "مدة العقد  ",
    english: "The duration of this contract is ",
  },
  {
    user_key: "balav_2_2",
    kurdish: "مانگە دەستپێدەکات لە بەرواری",
    arabic: "شهراً تبدأ من ",
    english: "months, it starts from ",
  },
  {
    user_key: "balav_2_3",
    kurdish: "تا",
    arabic: "إلى ",
    english: "to ",
  },
  {
    user_key: "balav_2_4",
    kurdish:
      "وە لەکاتی کوتایی هاتنی ماوەی ئاماژە پێکراو لەسەر لایەنی دووەمە کە شوینی بەکرێگیراو چۆل بکات بی ئەوەی پێویستی بە ئاگادار کردنەوەی هەبیت",
    arabic: "وعند انتهاء المدة على الطرف الثاني تخلية العقار دون تبليغ مسبق. ",
    english:
      "and when the above mentioned duration ends the second party should evacuate the leased property without the need to be notified.",
  },
  {
    user_key: "balav_3_1",
    kurdish: "هەردوو لایەن رەزامەندن لەسەر کرێی مانگانەی بە بڕی",
    arabic: "وافق كلا الطرفين على أجرة شهرية قدره ",
    english: "Both parties agree on the monthly lease fee with the amount of",
  },
  {
    user_key: "balav_4_1",
    kurdish: "لایەنی دووەم بڕی",
    arabic: "يدفع الطرف الثاني مبلغ قدره ",
    english: "The second party gives the amount of ",
  },
  {
    user_key: "balav_4_2",
    kurdish: "دەدات بە لایەنی یەکەم وەک پێشەکی",
    arabic: "كمقدمة ",
    english: "to the first party as the advance payment.",
  },
  {
    user_key: "balav_5_1",
    kurdish: "دوای پێشەکی کرێیەکە بەم شێوەیە دەدرێت",
    arabic: "بعد مبلغ المقدمة يتم دفع الأجرة على النحو التالي",
    english:
      "After the advance payment the lease fee payment will be as following",
  },
  {
    user_key: "balav_6_1",
    kurdish: "لایەنی دووەم پاپەند دەبیت بە پێدانی بڕی",
    arabic: "يلتزم الطرف الثاني بدفع مبلغ قدره ",
    english: "The second party will be committed to paying the amount of",
  },
  {
    user_key: "balav_6_2",
    kurdish:
      "وەك دلنيايى(تأمینات) بە دیڤاین  وه پێویستە لەسەر کرێچی کە پسولەی ئەسلی پێبێت بۆ داناوەی تەئمینات به مەرجيك لايەنى دووەم مۆڵكەكه بەبى بوونى هيج كەم و كوڕيەك رادەست بكاتەوه بە پێچەوانەوە پارە کە نادرێتەوە لایەنی دووەم .",
    arabic: "كتأمينات إلى دیڤاین  وفق ورقة الإيصال المرقمة ",
    english: "as insurance to Divine company as per the invoice number",
  },
  {
    user_key: "balav_7_1",
    kurdish: "لايەنى دووەم ئەم مۆلكه بەكاردێنيت بۆ مەبەستى ",
    arabic: "يستخدم الطرف الثاني هذا العقار لغرض ",
    english: "The second party will use this property for the purpose of",
  },
  {
    user_key: "balav_7_2",
    kurdish:
      "له كاتى بەكارهێنانى بۆ هەر مەبەستێكى تر پێويستە ئاگادارى دیڤاین  بكات و رەزامەندى لايەنى يەكەم به نوسراوو وەربگريت.به پێجەوانەوە مافى لايەنى يەكەمه ئەم گريبەستە هەڵبوشێنێتەوە بەبى ئاگادار كردنەوەى لايەنى دووەم",
    arabic:
      "وعند استخدامه لأي غرض آخر يجب تبيلغ دیڤاین  عن ذلك وبموافقة خطية من الطرف الأول. خلافاً لذلك يحق للطرف الأول إبطال العقد دون تبيلغ الطرف الثاني. ",
    english:
      "and when using it for any other purpose it should notify Divine company and to get a written agreement from the first party, otherwise the first party has the right to terminate this contract without notifying the second party.",
  },
  {
    user_key: "balav_8",
    kurdish:
      "لايەنى دووەم بەلێن دەدات كه پارێزگارى له شوێنى بەكرێگیراو بكات له كاتى سوود وەرگرتن له شوێنەكە وە دوورى بگرێت له تێكجوون و داڕمان وه بەكارنەهێنانى به شێوەیەكى نەخوازراو",
    arabic:
      "يتعهد الطرف الثاني بحماية العقار المستأجَر عن الاستفادة منه والحفاظ عليه من التلف والهدم وعدم استخدامه على شكل غير مرغوب فيه. ",
    english:
      "The second party promises that it will protect the leased property when using it and it also promises that it will protect the property from getting damaged and that it will not use it unfairly.",
  },
  {
    user_key: "balav_9",
    kurdish:
      "لايەنى یەکەم بۆى نيه شوێنى بەكرێگيراو بەكار بهێنێت ياخوود داواى كليلى موڵكەکە بكات بۆ هەر مەبەستێك بێت تا رێپێدانى ئاسايش ياخوود لايەنى پەيوەندیدار وەردەگرێت.بەپیچەوانەوه بەرپرسيار دەبيت بەرامبەر به ياسا",
    arabic:
      "لا يجوز للطرف الأول استخدام العقار المستأجَر أو يطالب بدیڤاینه إلى أن يتم الحصول على الرخصة الأمنية (من آسايش) أو الجهة المعنية؛ خلافاً لذلك يتحمل المسؤولية أمام القانون",
    english:
      "The first party doesn’t have the right to ask for the keys or to use the leased property for any purpose unless it gains the security clearance or the clearance from other related parties, otherwise it will be responsible in front of the law.",
  },
  {
    user_key: "balav_10",
    kurdish:
      "پێويستە لايەنى دووەم پێش بەكارهێنانى شوينى بەكرێگیراو لەسەر ئەستوى خۆى گشت قوفلى دەرگا دەركيەكان بگۆرێت.به پێچەوانە له كاتى روودانى هەر كێشەيەك تەنها خوودى خۆى بەرپرسيار دەبێت",
    arabic:
      "على الطرف الثاني تغيير كافة أقفال الأبواب الخارجية قبل استخدام العقار؛ خلافاً لذلك يتحمل المسؤولية هو بنفسه. ",
    english:
      "The second party should change all the lockers of all the main doors before using the leased property, otherwise in case of any problem the second party will solely be responsible for.",
  },
  {
    user_key: "balav_11",
    kurdish:
      "له بەروارى واژوو كردنى ئەم گرێبەستە خزمەتگوزاريەكانى پرۆژە و شارەوانى و كارەبا و ئاو وهەر خزمەت گوزاريەكى تر هەبيت له ئەستۆى لايەنى دووەم دەبيت",
    arabic:
      "	من تاريخ توقيع العقد يكون الطرف الثاني هو المسؤول عن دفع تكاليف الماء والكهرباء والبلدية وأية خدمة أخرى. ",
    english:
      "From the date of signing this contract all the expenses of the project, municipality, electricity, water and any other services will be the liability of the second party",
  },
  {
    user_key: "balav_12_1",
    kurdish: "ئەگەر لایەنی دووەم تاکو بەرواری ",
    arabic: "	في حال عدم الحصول على الرخصة من الجهة الأمنية حتى تاريخ ",
    english:
      "If the second party couldn’t gain the clearance from the related parties until",
  },
  {
    user_key: "balav_12_2",
    kurdish:
      "نەیتوانی ڕێپێدان لە لایەنی پەیوەندیدار وەربگرێ راستەوخۆ گرێبەستەکە هەڵدەوەشێتەوە وە ئەو بڕە کرێیەی کەوا دراوە دەگەرێنرێتەوە بۆ لایەنی دووەم",
    arabic: "يتم فسخ العقد مباشرة ويتم إرجاع المبلغ المستلم إلى الطرف الثاني. ",
    english:
      "in this case the contract will directly be terminated and the amount of the fee which is paid will be returned to the second party.",
  },
  {
    user_key: "balav_13",
    kurdish:
      "لایەنی دووەم پابەند دەبێ بە پێدانی کرێ لە کاتی دیاریکراو لەم گرێبەستە. لەکاتی دواکەوتن لە (7) رۆژ زیاتر ئەوە بە پێی برگەی (1) لە ماددەی (17) لە یاسای بەکرێدانی مۆڵک لە قانونی عێراقی ژمارە (87) ساڵی (1979) مامەڵەی لەگەل دەکرێ ئەویش بە چۆڵ کردنی موڵکەکە و تێچوی هۆشداری دادگا ئەکەوێتە ئەستۆی لایەنی دووەم لەگەل کرێی مانگانە.",
    arabic:
      "يتعهد الطرف الثاني بدفع الأجرة في الوقت المحدد في العقد. وإذا تأخر أكثر من (7) أيام فيتعامل معه حسب الفقرة (1) من المادة (17) من قانون تأجير العقار من القانون العراقي المرقم (87) لسنة (1979) وهي تخلية العقار مع تحمل تكاليف تبليغ المحكمة مع الأجرة الشهرية. ",
    english:
      "The second party will be committed to paying the lease fee at the specified time stated in this contract. And in the case of getting delayed for more than (7) days, then the second party will be dealt with according to the Clause (1) from article (17) in the law for leasing the properties of the Iraqi Law number (87) in the year (1979) which is evacuating the property and the expenses for the court notice plus the monthly lease fee will be the liability of the second party. ",
  },
  {
    user_key: "balav_14",
    kurdish:
      "ئەگەر شوێنى بەكرێگيراو راخراو بوو (مؤثث)لايەنى دووەم پێويستە پاريزگارى لە كەل و پەلەكان بكات و لەكاتى چۆل كردنى شوينى بەكرێگيراو وەك خۆى رادەستى لايەنى يەكەم بكاتەوە. بە پێچەوانەوە لايەنی دووەم بەرپرسە له چاككردنەوە يان گۆڕينى لەسەر ئەركى خۆى",
    arabic:
      "إذا كان العقار المؤجًّر مؤثثا على الطرف الثاني الحفاظ على الأثاث وعند التخلية يسلّمها كما كانت؛ خلافاً لذلك يكون الطرف الثاني مسؤولاً عن التصليح أو تبديله على مسؤوليته. ",
    english:
      "If the leased property was furnished, the second party should protect this stuff when evacuating the property, it should deliver to the first party as it was when being received. Otherwise, the second party will be responsible for repairing or changing the stuff on its own expense",
  },
  {
    user_key: "balav_15",
    kurdish:
      "لايەنى يەكەم پابەند دەبێت بە پێدانى پارەى حكومى و تايبەت(ئەهلى) و خزمەتگوزاريەكان و ئەستۆ پاكى بكات پيش بە كرێدان و واژوو كردنى ئەم گريبەستە",
    arabic:
      "	يتعهد الطرف الأول بدفع الرسومات الحكومية والخاصة والخدمات وبراءة الذمة قبل التأجير والتوقيع على العقد. ",
    english:
      "The first party will be committed to paying all the financial obligations whether public or private, services and clearance before leasing its property and signing this contract.",
  },
  {
    user_key: "balav_19_1",
    kurdish:
      "دوای تەواو بونی ماوەی ئەم گرێبەستە ئەگەر لایەنی دووەم پابەند نەبێ بە چۆڵکردن یان نوێکردنەوەی ئەم گرێبەستە ئەوا کرێی موڵکەکە دەبێت بە رۆژانە بە بڕی ",
    arabic:
      "بعد انتهاء مدة العقد في حال لم يلتزم الطرف الثاني بتخلية العقار أو تجديد العقد تكون أجرة العقار ",
    english:
      "When the duration of this contract ends if the second party is not committed to evacuating the property or renewing this contract in this case the lease fee of the property will be on daily basis ",
  },
  {
    user_key: "balav_19_2",
    kurdish: "بۆ هەر رۆژێک هەژمار دەکرێت تا ئەو کاتەی کێشەکە یەکلایی دەبێتەوە",
    arabic: "إزاء كل يوم إلى أن يتم حسم القضية. ",
    english: "for each day will be counted until the problem is being solved.",
  },
  {
    user_key: "balav_23",
    kurdish:
      "ئەگەر لەماوەی ئەم گرێبەستە خاوەنداریەتی ئەم موڵکە گواسترایەوە بۆ هەر لایەنێکی تر ئەوا ئەبێ خاوەنە نوێیەکەی پابەندی نێوەرۆکی ئەم گرێبەستە بێ",
    arabic:
      "إذا تم نقل الملكية للعقار إلى طرف آخر يجب على الصاحب الجديد  الإلتزام بمضمون هذا العقد.  ",
    english:
      "As far as this contract is active and if the property ownership transferred to another party then the new owner should commit to the content of this contract.",
  },
  {
    user_key: "balav_28",
    kurdish:
      "هەر یەک لە لایەنی یەکەم و لایەنی دووەم پێوستە بڕی کرێی نیو مانگ بۆ هەر ساڵێک بدەن بە   دیڤاین  لە بڕی رێکخستنی ئەم گرێبەستە",
    arabic:
      "على الطرفين دفع نصف مبلغ الأجرة سنوياً إلى دیڤاین  بدل تظيم هذا العقد. ",
    english:
      "Each one of the first and the second party should pay half a month lease fee to Divine  Company for arranging this contract.",
  },
  {
    user_key: "balav_29",
    kurdish:
      "لەکاتی چۆڵکردن شوێنی بەکرێ گیراو پێویستە لایەنی دووەم چۆن موڵکەکەی وەرگرتوە وەک خۆی بەبێ کەم و کورتی رادەستی لایەنی یەکەم بکاتەوە، بەپێچەوانەوە بەرپرسە لە چاککردنەوەی کەم وکوریەکان بەزوترین کات",
    arabic:
      "عند تخلية العقار يجب على الطرف الثاني تسليم العقار كما استلمه دون نقصان خلافا لذلك يتحمل المسؤولية لسد النواقص بأسرع وقت ممكن. ",
    english:
      "When evacuating the leased property the second party should deliver the property to the first party as it was when being received without any damage or shortage otherwise it will be responsible for repairing the shortages as soon as possible",
  },
  {
    user_key: "balav_30",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی پارەی ئاو و کارەبای نیشتمانی لەگەل هاتنەوەی پسولە وە پێویستە لەکاتی چؤل کردن شوێنی بەکرێگیراو سەردانی فەرمانگەکان بکات بۆ پێدانی ئەو بڕە قەرزەی کە لەئەستۆیەتی وە پابەند دەبێت بە دەرخستنی گشت پسولەکان بە پێچەوانەوە بەرپرسیار دەبێت بەرامبەر بە یاسا",
    arabic:
      "يتعهد الطرف الثاني بدفع تكاليف الماء والكهرباء الوطنية مع مجيء ورقة القبض وعند التخلية عن العقار المؤجر عليه زيارة الدوائر لدفع القرض المتبقى عليه خلافا لذلك يتحمل المسؤولية أمام القانون. ",
    english:
      "The second party is committed to paying for water, public electricity at the time of receiving the invoice and it is a must that during evacuating the least property to visit the related governmental organizations to pay off any remaining debt And will be committed for preparing all invoices otherwise will be responsible in front of law.",
  },
  {
    user_key: "balav_31",
    kurdish:
      "لەکاتی نوێ کردنەوەی گرێبەست هەر لایەنێک پابەند دەبێت بە پێدانی کرێی نیو مانگ بۆ یەک ساڵ بە   دیڤاین ",
    arabic:
      "يتعهد الطرفان عند تجديد العقد بدفع نصف مبلغ الأجرة سنوياً إلى دیڤاین . ",
    english:
      "When renewing the contract each party will be committed to paying the amount of the lease fee for half a month to Divine Company for each year. ",
  },
  {
    user_key: "balav_32",
    kurdish:
      "لایەنی دووەم بەهیچ شێوەیەک نابێت ببێتە مایەی ئەزیەت و ئازار بۆ دراوسێیەکانی و بە پێچەوانەوە بەرپرسیار دەبێت و گرێبەستەکە هەڵدەوەشێتەوە",
    arabic:
      "لا يحق للطرف الثاني بأي وجه من الوجوه أم يخلق مشاكل مع جيران خلافاً لذلك يتحمل المسؤولية ويتم فسخ العقد. ",
    english:
      "The second party should not be in any way the source of disturbance to its neighbors; otherwise it will be responsible and will cause the contract termination.",
  },
  {
    user_key: "comision",
    kurdish: "عمولە",
    arabic: "عمولة",
    english: "comision",
  },
  {
    user_key: "Housing",
    kurdish: "نیشتەجێبوون",
    arabic: "سکنیة",
    english: "Housing",
  },
  {
    user_key: "office",
    kurdish: "ئۆفیس",
    arabic: "مكتب",
    english: "office",
  },
  {
    user_key: "balav_33",
    kurdish:
      "لەکاتی چارەسەر نەبوونی کێشەی لایەنی یەکەم و دووەم بە شێوازی گفتوگۆ و دانوستاندن ئەوا   دیڤاین  بەرپرس نیە و نابێت بەڵکو پێویستە لەسەر لایەنەکان کێشەکە چارەسەر بکەن بەگرتنەبەری رێکاری یاسایی و پەنابردن بۆ دادگای تایبەت",
    arabic:
      "عند عدم حسم المشاكل بالحوار فيما بين الطرفين لا تتحمل دیڤاین  المسؤولية بل على الطرفين أن يحسم القضايا من خلال إجراءات قانونية واللجوء إلى محكمة خاصة. ",
    english:
      "In case of inability to solve the problem of the first and second parties through negotiations then Divine Company is not responsible and will not be responsible but the parties should solve the problem through legal proceedings and to go to a specialized court.",
  },
  /**
   * Sell contract balav
   */
  {
    user_key: "S_balav_1_1",
    kurdish: "من ",
    arabic: "إني ",
    english: "My name is ",
  },
  {
    user_key: "S_balav_1_2",
    kurdish:
      "خاوەن موڵك ڕەزامەندم بە فرۆشتنی ئەم موڵكەی لە سەرەوە ئاماژەی پێكراوە بە بڕی ",
    arabic: "صاحب الملك وافقت على بيع العقار المذكور أعلاه بمبلغ قدره ",
    english:
      "the property owner, I agree to sell the above mentioned property with the amount of ",
  },
  {
    user_key: "S_balav_2",
    kurdish:
      "من لایەنی دووەم ڕەزامەندم بە كڕینی ئەم موڵكەی لە سەرەوە ئاماژەی پێكراوە بەبڕی ",
    arabic: "إني الطرف الثاني وافقت على شراء العقار المذكور أعلاه بمبلغ قدره ",
    english:
      "Me as the second party, I agree to buy the above mentioned property with the amount of ",
  },
  {
    user_key: "S_balav_3_1",
    kurdish: "لایەنی دووەم بڕی ",
    arabic: "يدفع الطرف الثاني مبلغاً قدره",
    english: "The second party has paid the amount of ",
  },
  {
    user_key: "S_balav_3_2",
    kurdish: "رادەستی لایەنی یەکەم کرد وەکو پێشەکی",
    arabic: "إلى الطرف الثاني كمقدمة",
    english: "to the first party as advance payment",
  },
  {
    user_key: "S_balav_4",
    kurdish:
      "ئەو برە پارەیەی کە لەئەستۆی لایەنی دووەم ماوە بیدات بە لایەنی یەکەم بەم شێوەی خوارەوە دەدرێت (کاش-قسط)",
    arabic:
      "يتم دفع المبلغ المتبقي على الطرف الثاني إلى الطرف الأول على النحو التالي: (نقداً - أقساط).   ",
    english:
      "The amount of money which the second party is due to pay to the first party, will pay as the following (Cash- Installment)",
  },
  {
    user_key: "S_balav_5",
    kurdish:
      "لەسەر لایەنی یەكەم پێویستە ئەم موڵكە ڕادەستی لایەنی دووەم بكات دوای وەرگرتنی تەواوی شایستە داراییەکانی لە رێكەوتی",
    arabic:
      "على الطرف الأول تسليم العقار إلى الطرف الثاني بعد استلام كافة مستحقاته المالية  في ",
    english:
      "The first party should deliver this property to the second party after receiving all its financial entitlements in ",
  },
  {
    user_key: "S_balav_6",
    kurdish:
      "ئەگەر هاتوو لایەنی یەكەم لە رێكەوتی دیاریكرودا ئەو موڵكەی ڕادەستی لایەنی دووەم نەكرد ئەوە دەبێت پابەندبێت بێت بە پێدانی بڕی ",
    arabic:
      "في حال تأخر الطرف الأول من تسليم العقار إلى الطرف الثاني عليه دفع مبلغ قدره ",
    english:
      "If the first party didn’t deliver this property to the second party at the specified date, then it should commit to paying the amount of ",
  },
  {
    user_key: "S_balav_6_2",
    kurdish: "وەكوو پێبژاردن (غرامة) بۆ هەر رۆژێک",
    arabic: "كغرامة لكل يوم تأخير",
    english: "as fine for each day to the second party",
  },
  {
    user_key: "S_balav_7",
    kurdish:
      "لایەنی یەکەم لەئەستۆیەتی تا بەرواری رادەست کردنی موڵکەکە بە پێدانی هەر قەرزێک ئەگەر هەبێت لە خزمەتگوزاری ئاو کارەبا سەبارەت بە موڵکی ئاماژە پێکراو",
    arabic:
      "على الطرف الأول تصفية تكاليف ورسومات الماء والكهرباء أو أي قرض آخر قبل موعد تسليم العقار المذكور. ",
    english:
      "The first party is liable to pay for any debt of the services like electricity or water of the mentioned property if there is any until the date of delivering the property to the second party.",
  },
  {
    user_key: "S_balav_8",
    kurdish:
      "ئەگەر هاتوو هەر لایەنێك بە هەر هۆیەك پاشگەز بێتەوە لەم گرێبەستە دەبێت  لایەنەكەی تر قەرەبوو بکاتەوە بە ",
    arabic: "في حال عدول أحد الاطراف، أياَ كان السبب، يجب دفع مبلغ قدره ",
    english:
      "If any party regretted from this contract due to any reason it should commit to pay the amount of ",
  },
  {
    user_key: "S_balav_8_2",
    kurdish:
      "وەكوو پێبژاردن  بە لایەنەكەی تروەکو قەرەبوو بەبێ چوون بۆ دادگا یان ناردنی هۆشداری. ئەم برگەیەش شایانی جێبەجێ کردنە لە بەرێوبەرایەتی جێبەجێکردنی هەولێرراستەوخۆ وە بری قەرەبوەکەش   دیڤاین  دیاری دەکات",
    arabic:
      "كغرامة وتعويض إلى الطرف الآخر دون الرجوع إلى المحكمة أو إرسال تبليغ. تصلح هذه الفقرة للتنفيذ في مديرية تنفيذ أربيل مباشرة ويتم تحديد مبلغ التعويض عن طريق دیڤاین ",
    english:
      "as penalty to the other party as compensation without going to court or giving a notice. This clause is applicable in Erbil Directorate of Implementation directly, and the amount for compensation will be put by Divine Company.",
  },
  {
    user_key: "S_balav_9",
    kurdish:
      "هەر لایەک بەرپرس بێ لە بەندی (8)ی ئەم گرێبەستە ئەوا پابەندە بە پێدانی بڕی 2%ی نرخی موڵکەکە بە  دیڤاین  لەبری هەردوولایەن",
    arabic:
      "يلتزم الطرف المسؤول عن البند (8) من هذا العقد بدفع 2% من سعر العقار إلى دیڤاین  بديلاً عن الطرفين. ",
    english:
      "Any party which is responsible in the clause (8) in this contract will automatically be committed to pay the amount of (2%) of the property price to Divine Company instead of both parties.",
  },
  {
    user_key: "S_balav_10",
    kurdish:
      "تێچوو و ڕسوماتی فرۆشتن و گواستنەوە و جیاكردنەوە و یەكخستن و ڕاستكردنەوە و باجی خانووبەرە لەسەر لایەنی یەكەمە بیدات بەپێی یاسا ئەگەر تاپۆ بوو. بەڵام ئەگەر تاپۆ نەبوو لایەنی یەكەم پابەندە بە پێدانی بڕی تێچوی گواستنەوەی خاوەنداریەتی",
    arabic:
      "تقع تكاليف ورسومات البيع والنقل والفرز والتوحيد والتعديل وضريبة العقار على الطرف الأول وفق القانون إذا كان للعقار سند طابو. وفي حال لم يكن للعقار سند طابو على الطرف الأول دفع تكاليف نقل الملكية. ",
    english:
      "The expenses and fees for selling, transferring, separation, integration, correction and real estate tax will be paid by the first party according to Law if the property is registered on his/her name. But, if the property is not registered on his/her name then the first party is committed to paying all the expenses for transferring the ownership.",
  },
  {
    user_key: "S_balav_11",
    kurdish:
      "تێچووی ڕسوماتی كەشف و تۆماری عەقاری دەكەوێتە سەر لایەنی دووەم بە گوێرەی یاسا ئەگەر موڵكەكە تاپۆ بوو. وە ئەگەر تاپۆ نەبوو ئەوە لایەنی دووەم بە پێدانی بڕی پارەی بەناوكردن",
    arabic:
      "يكون الطرف الثاني مسؤولاً عن تسديد رسومات الكشف والتسجيل العقاري وفق القانون في حال كان للعقار سند طابو، وإذا لم يكن للعقار سند طابو على طرف الثاني دفع تكاليف التسجيل. ",
    english:
      "The expenses for inspection and real estate registration will be paid by the second party according to law if the property is registered on his/her name. But, if the property is not registered on his/her name then the second party should pay for registration expenses.",
  },
  {
    user_key: "S_balav_12_1",
    kurdish:
      "پاش واژوکردن لەسەر ئەم گرێبەستە ئەگەر هاتوو مولکی فرۆشراو تاپۆی هەبوو پێویستە لەسەرلایەنی یەکەم کەوا بریکارنامە بدات بە پارێزەر",
    arabic:
      "بعد التوقيع على هذا العقد في حال كان للعقار المباع سند طابو، يجب على الطرف الأول منح وكالة إلى المحامي",
    english:
      "After signing this contract if the sold property was registered on the first party’s name then the first party should give the agency to a lawyer: for the purpose of transferring the ownership and registering the sold property for the second party.",
  },
  {
    user_key: "S_balav_12_2",
    kurdish:
      "بەمەبەستی گواستنەوەی خاوەنداریەتی و تۆمارکردنی موڵکی فرۆشراو بۆ لایەنی دووەم",
    arabic: "لغرض نقل الملكية وتسجيل العقار المباع لصالح الطرف الثاني. ",
    english:
      "After signing this contract if the sold property was registered on the first party’s name then the first party should give the agency to a lawyer: for the purpose of transferring the ownership and registering the sold property for the second party.",
  },
  {
    user_key: "S_balav_13",
    kurdish:
      "لایەنی یەکەم پابەند دەبێ بە پێدانی رێژەی %1 لەنرخی موڵکی ئامێژەپێکراو لەم گرێبەستە بە   دیڤاین  لەبەرامبەر فرۆشتنی ئەم موڵکە ",
    arabic:
      "يتعهد الطرف الأول بدفع نسبة 1% من سعر العقار المذكور في هذا العقد إلى دیڤاین  إزاء بيع العقار ",
    english:
      "The first party is committed to pay (1%) of the property price put in this contract to Divine Company for selling this property.",
  },
  {
    user_key: "S_balav_14",
    kurdish:
      "لایەنی دووەم پابەند دەبێ بە پێدانی رێژەی %1 لەنرخی موڵکی ئامێژەپێکراو لەم گرێبەستە بە   دیڤاین  لەبەرامبەر کرینی ئەم موڵکە ",
    arabic:
      "يتعهد الطرف الثاني بدفع نسبة 1% من سعر العقار المذكور في هذا العقد إلى دیڤاین  إزاء بيع العقار ",
    english:
      "The second party is committed to pay (1%) of the property price put in this contact to Divine Company for buying this property.",
  },
  {
    user_key: "S_balav_15",
    kurdish:
      "لەکاتی هەبونی هەر کێشەیەک سەبارەت بەناوەرۆکی ئەم گرێبەستە بە پێویستە لەسەر هەردوولایەن سەرەتا بە شێوازی دانوستاندن و گفتوگۆ کێشەکە چارەسەر بکەن. بەلام ئەگەر چارەسەر نەکرا ئەوا لەرێگەی دادگاکانی هەولێر چارەسەر دەکرێ",
    arabic:
      "في حال حدوث أي نزاع حول مضمون هذا العقد على الطرفين حله عن طريق الحوار وإلا تكون محكمة أربيل محل بتّ القضايا",
    english:
      "In case of any problem regarding the content of this contract, both parties should solve the problem based on negotiations. But if this didn’t help then it will be solved through Erbil Courts.",
  },
  {
    user_key: "6_pezan",
    kurdish:
      "  دیڤاین  هاوکاری هەردوو لایەن دەبێ تا کۆتایی هاتنی بەرواری گرێبەستەکە بۆ مانەوە و بەردەوامی گرێبەستەکە وە چارەسەرکردنی هەر کێشەیەک ئەگەر هەبوو، دیڤاین  بەرپرس نیە تەنها نێوەندگیرە.",
    arabic:
      "تتعتون دیڤاین  مع الطرفين لحين نهاية تاريخ العقد لغرض البقاء و استمرارية العقد و معالجة اى مشكلة ان وجدت, و العقارات ليست مسؤولة تنجم بعد ذلك ... وهي تعمل مجرد كوسيط",
    english:
      "Divine Realestate shall assist both parties until the end of the contract for subsistence and continuance of the contract and solving their problems if there is any, but the company is not responsible for any disputes arise between them. It is only an intermediary",
  },
  {
    user_key: "Brikar",
    kurdish: "ناوی بریکار",
    arabic: "اسم الوكيل",
    english: "Brikar",
  },

  // note of Rent Contract Contrcat
  {
    user_key: "note_6",
    kurdish: "نمونە: ..٣ دۆلار",
    arabic: "",
    english: "",
  },
  {
    user_key: "note_5",
    kurdish: "نمونە ٣ مانگ",
    arabic: "",
    english: "",
  },
  {
    user_key: "note_4",
    kurdish: "نمونە: ١٢ مانگ",
    arabic: "",
    english: "",
  },
  {
    user_key: "note_3",
    kurdish: "نمونە: کریکە ٢ مانگ جارێکە",
    arabic: "",
    english: "",
  },
  {
    user_key: "note_2",
    kurdish: "سزای ڕادەستنەکردنی موڵک لەسەر لایەنی یەکەمە",
    arabic: "",
    english: "",
  },
  {
    user_key: "note_1",
    kurdish: "سزای دووای تەواو بوونی گرێبەست لەسەر لایەنی دووەمە",
    arabic: "",
    english: "",
  },
  {
    user_key: "Building",
    kurdish: "باڵەخانە",
    arabic: "بناء",
    english: "Building",
  },
  {
    user_key: "Agitator",
    kurdish: "ئارایشتگە",
    arabic: "صالۆن",
    english: "Agitator",
  },
  {
    user_key: "residential community",
    kurdish: "کۆمەلگەی نیشتەجێبوون",
    arabic: "مجتمع سكني",
    english: "residential community",
  },
  {
    user_key: "agricultural land of the register",
    kurdish: "زەوی کشتوکاڵی تاپۆ",
    arabic: "الأراضي الزراعية للسجل",
    english: "agricultural land of the register",
  },
  {
    user_key: "unregistered agricultural land",
    kurdish: "زەوی کشتوکاڵی  بێ تاپۆ",
    arabic: "الأراضي الزراعية غير المسجلة",
    english: "unregistered agricultural land",
  },
  {
    user_key: "Government agricultural land",
    kurdish: "زەوی کشتوکاڵی حکومەت",
    arabic: "الأراضي الزراعية الحكومية",
    english: "Government agricultural land",
  },
  {
    user_key: "Land of Istamar",
    kurdish: "زەوی استسمار",
    arabic: "ارض استسمار",
    english: "Land of Istamar",
  },
  {
    user_key: "Erth Musataha",
    kurdish: "زەوی مساتەحە",
    arabic: "ارض مساتەحە",
    english: "Erth Musataha",
  },
  {
    user_key: "school",
    kurdish: "قوتابخانە",
    arabic: "مدرسة",
    english: "school",
  },
  {
    user_key: "Building of Istamar",
    kurdish: "بالەخانە استسمار",
    arabic: "بناء استسمار",
    english: "Building of Istamar",
  },
  {
    user_key: "Building of Musataha",
    kurdish: "بالەخانەی مساتحە",
    arabic: "بناء مساتحە",
    english: "Building of Musataha",
  },
  {
    user_key: "Customer Detail",
    kurdish: "زانیاری کڕیار",
    arabic: "تفاصيل العميل",
    english: "Customer Detail",
  },
  {
    user_key: "Customer Detail List",
    kurdish: "لیستی زانیاری کڕیار",
    arabic: "قائمة تفاصيل العملاء",
    english: "Customer Detail List",
  },
  {
    user_key: "Min Price",
    kurdish: "کەمترین نرخ",
    arabic: "الحد الأدنى للسعر",
    english: "Min Price",
  },
  {
    user_key: "MAx Price",
    kurdish: "زۆرترین نرخ",
    arabic: "الحد الأقصى للسعر",
    english: "MAx Price",
  },
  {
    user_key: "Add Customer",
    kurdish: "زیادکردنی کڕیار",
    arabic: "إضافة عميل",
    english: "Add Customer",
  },
  //
  {
    user_key: "Company Seals",
    kurdish: "مۆری کۆمپانیا",
    arabic: "أختام الشركة",
    english: "Company Seals",
  },
  {
    user_key: "Base Signature",
    kurdish: "واژووی بنکە",
    arabic: "التوقيع الأساسي",
    english: "Base Signature",
  },
  {
    user_key: "Nation",
    kurdish: "نەتەوە",
    arabic: "القومية",
    english: "Nation",
  },
  {
    user_key: "Property number (electricity number)",
    kurdish: "ژمارەی موڵك (ژمارەی کارەبا)",
    arabic: "رقم العقار (رقم الكهرباء)",
    english: "Property number (electricity number)",
  },
  {
    user_key: "Property Address",
    kurdish: "ناونیشانی موڵك",
    arabic: "عنوان العقار",
    english: "Property Address",
  },
  {
    user_key: "Where to go",
    kurdish: "شوێنی ڕۆیشتنی",
    arabic: "إلى أين أذهب",
    english: "Where to go",
  },

  {
    user_key: "Number of family members",
    kurdish: "ژمارەی ئەندامانی خێزان",
    arabic: "عدد أفراد الأسرة",
    english: "Number of family members",
  },
  {
    user_key: "Number of family members_",
    kurdish: "ژ.ئەندامانی خێزان",
    arabic: "عدد أفراد الأسرة",
    english: "Number of family members",
  },
  {
    user_key: "Current tenant",
    kurdish: "کرێچی ئێستا",
    arabic: "المستأجر الحالي",
    english: "Current tenant",
  },
  {
    user_key: "Former tenant's",
    kurdish: "کرێچی پێشوو",
    arabic: "المستأجر السابق",
    english: "Former tenant's",
  },
  {
    user_key: "Former tenant's name",
    kurdish: "ناوی کرێچی پێشوو",
    arabic: "اسم المستأجر السابق",
    english: "Former tenant's name",
  },

  {
    user_key: "Owner of the property",
    kurdish: "خاوەن موڵك",
    arabic: "مالك العقار",
    english: "Owner of the property",
  },
  {
    user_key: "Real Estate Address",
    kurdish: "ناونیشانی عقارات",
    arabic: "عنوان عقارات",
    english: "Real Estate Address",
  },
  {
    user_key: "Name of the owner of the property",
    kurdish: "ناوی خاوەن عقارات",
    arabic: "اسم مالك العقار",
    english: "Name of the owner of the property",
  },

  {
    user_key: "Subject : Residential consent",
    kurdish: "بابەت : ڕەزامەندی نیشتەجێبوون",
    arabic: "الموضوع : الموافقة السكنية",
    english: "Subject : Residential consent",
  },
  {
    user_key: "Seller Anket",
    kurdish: "ئەنکێتی کڕیار",
    arabic: "ئەنکێتی کڕیار",
    english: "Seller Anket",
  },
  {
    user_key: "List of Seller Anket",
    kurdish: "لیستی ئەنکێتی کڕیار",
    arabic: "لیستی ئەنکێتی کڕیار",
    english: "List of Seller Anket",
  },
  {
    user_key: "Recurrence",
    kurdish: "دووبارەبوونەوە",
    arabic: "تكرار",
    english: "Recurrence",
  },
  {
    user_key: "next Repayment",
    kurdish: "پارەوەرگرتنی داهاتوو",
    arabic: "التالي السداد",
    english: "next Repayment",
  },
  {
    user_key: "Contract Date",
    kurdish: "بەرواری گرێبەست",
    arabic: "تاريخ العقد",
    english: "Contract Date",
  },
  {
    user_key: "Day",
    kurdish: "ڕۆژ",
    arabic: "يوم",
    english: "Day",
  },
  {
    user_key: "Only",
    kurdish: " ، تەنها ",
    arabic: " فقط لا غير ,",
    english: ",Only",
  },
  {
    user_key: "You want to hold this apartment",
    kurdish: "دەتەوێ ئەم شوقەیە حجز بکەی؟",
    arabic: "تريد الاحتفاظ بهذه الشقة",
    english: "You want to hold this apartment?",
  },
  {
    user_key: "You want to cancel hold this apartment",
    kurdish: "دەتەوێ پاشتگەزببیەوە لە حجزکردنی ئەم شوقەیە؟",
    arabic: "تريد إلغاء عقد هذه الشقة",
    english: "You want to cancel hold this apartment",
  },
  {
    user_key: "Yes, cancel it",
    kurdish: "بەڵێ، پاشتگەزبوونەوە",
    arabic: "نعم ، الغاء",
    english: "Yes, cancel it",
  },
  {
    user_key: "Yes, hold it",
    kurdish: "بەڵێ، حجز بکە",
    arabic: "نعم ، امسكها",
    english: "Yes, hold it",
  },
  {
    user_key: "action",
    kurdish: "کردارەکان",
    arabic: "افعال",
    english: "action",
  },
  {
    user_key: "Does the money go into the box?",
    kurdish: "ئایا پارەکە بچێتە ناو سندوق",
    arabic: "هل يذهب المال إلى الصندوق؟",
    english: "Does the money go into the box?",
  },
  {
    user_key: "Is the money going to go out of the box؟",
    kurdish: "ئایا پارە بچێتە دەر لە سندوق",
    arabic: "هل سيخرج المال من الصندوق؟",
    english: "Is the money going to go out of the box؟",
  },
  {
    user_key: "Fast-selling contracts",
    kurdish: "گرێبەستی فرۆشتن خێرا",
    arabic: "عقود البيع السريع",
    english: "Fast-selling contracts",
  },
  {
    user_key: "Fast rental contracts",
    kurdish: "گرێبەستی کرێ خێرا",
    arabic: "عقود الإيجار السريعة",
    english: "Fast rental contracts",
  },
  {
    user_key: "Fast contracts",
    kurdish: "گرێبەستە خێراکان",
    arabic: "عقود سريعة",
    english: "Fast contracts",
  },
  {
    user_key: "Rejected",
    kurdish: "خێرا",
    arabic: "سريع",
    english: "fast",
  },
  {
    user_key: "type of contract",
    kurdish: "جۆری گرێبەست",
    arabic: "اختر نوع عقد",
    english: "type of contract",
  },
  {
    user_key: "Rejected",
    kurdish: "خێرا",
    arabic: "سريع",
    english: "fast",
  },
  {
    user_key: "The company's signature",
    kurdish: "واژووی کۆمپانیا",
    arabic: "توقيع الشركة",
    english: "The company's signature",
  },
  {
    user_key: "priority",
    kurdish: "ئەولەویەت",
    arabic: "أولوية",
    english: "priority",
  },
  {
    user_key: "source",
    kurdish: "سەرچاوە",
    arabic: "مصدر",
    english: "source",
  },
  {
    user_key: "Assighn_to_Agent",
    kurdish: "ناردنی بۆ کارمەند",
    arabic: "إرسال إلى الموظفين",
    english: "Assighn to Agent",
  },
  // priority
  {
    user_key: "urgent",
    kurdish: "بەپەلە",
    arabic: "مستعجل",
    english: "urgent",
  },
  {
    user_key: "normal",
    kurdish: "ئاسایی",
    arabic: "عادي",
    english: "normal",
  },
  // source
  {
    user_key: "homele",
    kurdish: "هۆمڵی",
    arabic: "هوملی",
    english: "homele",
  },
  {
    user_key: "Socila_Media",
    kurdish: "تۆڕە کۆمەڵایەتییەکان",
    arabic: "وسائل التواصل الاجتماعي",
    english: "Socila_Media",
  },
  {
    user_key: "Another",
    kurdish: "یەکێکی تر",
    arabic: "آخر",
    english: "Another",
  },
  //
  {
    user_key: "List Calls",
    kurdish: "لیستی پەیوەندیەکان",
    arabic: "قائمة المكالمات",
    english: "Another",
  },
  {
    user_key: "Add Call",
    kurdish: "زیادکردنی پەیوەندی",
    arabic: "إضافة مكالمة",
    english: "Add Call",
  },
  {
    user_key: "Customer",
    kurdish: "کڕیار",
    arabic: "زبون",
    english: "Customer",
  },
  {
    user_key: "Call Type",
    kurdish: "جۆری پەیوەندی",
    arabic: "نوع المكالمة",
    english: "Call Type",
  },
  {
    user_key: "call Response",
    kurdish: "جۆری وەڵام دانەوە",
    arabic: "الاستجابة للمكالمة",
    english: "call Response",
  },
  //Call Type
  {
    user_key: "incoming_call",
    kurdish: "پەیوەندی هاتوو",
    arabic: "مكالمة واردة",
    english: "incoming call",
  },
  {
    user_key: "outgoing_call",
    kurdish: "پەیوەندی دەرچوو",
    arabic: "مكالمة صادرة",
    english: "outgoing call",
  },
  //call response
  {
    user_key: "response",
    kurdish: "وەڵامدراوەتەوە",
    arabic: "استجابه",
    english: "response",
  },
  {
    user_key: "Wrong_Number",
    kurdish: "ژمارەی هەڵە",
    arabic: "رقم خاطئ",
    english: "Wrong Number",
  },
  {
    user_key: "not_response",
    kurdish: "وەڵامنەدراوەتەوە",
    arabic: "لا استجابة",
    english: "Not Response",
  },
  {
    user_key: "CalledBy",
    kurdish: "وەڵامدانەوەی پەیوەندی",
    arabic: "تم الاتصال به",
    english: "CalledBy",
  },
  {
    user_key: "Call Time",
    kurdish: "کاتی پەیوەندی کردن",
    arabic: "وقت المكالمة",
    english: "Call Time",
  },
  // visit
  {
    user_key: "Time to visit",
    kurdish: "کاتی سەردانیکردن",
    arabic: "وقت الزيارة",
    english: "Time to visit",
  },
  //service
  {
    user_key: "customer service",
    kurdish: "خزمەتگوزاری کڕیار",
    arabic: "خدمة الزبائن",
    english: "customer service",
  },
  {
    user_key: "List customer service",
    kurdish: "لیستی خزمەتگوزاری کڕیار",
    arabic: "قائمة خدمة الزبائن",
    english: "List customer service",
  },
  // service type
  {
    user_key: "Service Type",
    kurdish: "جۆری خزمەتگوزاری",
    arabic: "نوع الخدمة",
    english: "Service Type",
  },
  {
    user_key: "tax_payment",
    kurdish: "پارەدانی باج",
    arabic: "دفع الضرائب",
    english: "tax payment",
  },
  {
    user_key: "Properties management",
    kurdish: "بەڕێوەبردنی موڵك",
    arabic: "إدارة الأملاك",
    english: "Properties management",
  },
  {
    user_key: "furnituring",
    kurdish: "کەلوپەل",
    arabic: "تأثيث",
    english: "furnituring",
  },
  {
    user_key: "nationality",
    kurdish: "نەتەوەیی",
    arabic: "جنسية",
    english: "nationality",
  },
  // accountant
  {
    user_key: "Accounting",
    kurdish: "ژمێریاری",
    arabic: "الحسابات",
    english: "Accounting",
  },
  {
    user_key: "Persentage Payment Form",
    kurdish: "فۆڕمی پێدانی نسبە",
    arabic: "نموذج دفع النصبة",
    english: "Persentage Payment Form",
  },
  {
    user_key: "Persentage Payment Form Agents",
    kurdish: "فۆڕمی پێدانی نسبە بە کارمەندەکان",
    arabic: "نموذج دفع النصبة",
    english: "Persentage Payment Form Agents",
  },
  {
    user_key: "Monthly Percentage",
    kurdish: "نسبەی مانگی",
    arabic: "النسبة الشهرية",
    english: "Monthly Percentage",
  },
  {
    user_key: "Salary Payment Form",
    kurdish: "فۆڕمی پێدانی مووچە",
    arabic: "نموذج دفع الراتب",
    english: "Salary Payment Form",
  },
  {
    user_key: "List Salary",
    kurdish: "لیستی مووچە",
    arabic: "قائمة الرواتب",
    english: "List Salary",
  },
  {
    user_key: "Reward and Punishment Form",
    kurdish: "فۆڕمی پاداشت و سزا",
    arabic: "نموذج الثواب والعقاب",
    english: "Reward and Punishment Form",
  },
  {
    user_key: "Add Form",
    kurdish: "زیادکردنی فۆڕم",
    arabic: "اضافە نموذج",
    english: "Add Form",
  },
  {
    user_key: "Monthly Salary",
    kurdish: "مووچەی مانگی",
    arabic: "الراتب الشهري",
    english: "Monthly Salary",
  },
  {
    user_key: "bonus",
    kurdish: "پاداشت",
    arabic: "الثواب",
    english: "bonus",
  },
  {
    user_key: "punish",
    kurdish: "سزا(غرامە)",
    arabic: "غرامە",
    english: "punish",
  },
  {
    user_key: "punish/bounes",
    kurdish: "پاداشت/سزا",
    arabic: "غرامە/الثواب",
    english: "punish/bounes",
  },
  {
    user_key: "note_",
    kurdish: "تێبینی",
    arabic: "ملاحظة",
    english: "Note",
  },
  {
    user_key: "Salary",
    kurdish: "مووچە",
    arabic: "راتب",
    english: "Salary",
  },
  {
    user_key: "Percentage",
    kurdish: "ڕێژەی سەدی",
    arabic: "نسبه",
    english: "Percentage",
  },
  {
    user_key: "Specify your expenses.",
    kurdish: "خەرجیەکەت دیاریبکە",
    arabic: "حدد نفقاتك.",
    english: "Specify your expenses.",
  },
  {
    user_key: "Create Cost",
    kurdish: "دروستکردنی خەرجی",
    arabic: "إنشاء النفقات",
    english: "Create Cost",
  },
  {
    user_key: "expenses (Kurdish)",
    kurdish: "خەرجی (کوردی)",
    arabic: "النفقات (كردي)",
    english: "expenses (Kurdish)",
  },
  {
    user_key: "expenses (Arabic)",
    kurdish: "خەرجی (عربي)",
    arabic: "النفقات (عربي)",
    english: "expenses (Arabic)",
  },
  {
    user_key: "expenses (English)",
    kurdish: "خەرجی (ئینگلیزی)",
    arabic: "النفقات (إنجليزي)",
    english: "expenses (English)",
  },
  {
    user_key: "List of Cost Types",
    kurdish: "لیستی جۆرەکانی خەرجی",
    arabic: "قائمة أنواع التكاليف",
    english: "List of Cost Types",
  },
  {
    user_key: "Increase spending",
    kurdish: "زیادکردنی خەرجی",
    arabic: "زيادة الإنفاق",
    english: "Increase spending",
  },
  {
    user_key: "Expense bill",
    kurdish: "پسوولەی خەرجی",
    arabic: "فاتورة المصروفات",
    english: "Expense bill",
  },
  {
    user_key: "Accounting Report",
    kurdish: "ڕاپۆرتی ژمێریاری",
    arabic: "الحسابات",
    english: "Accounting Report",
  },
  {
    user_key: "Box Report",
    kurdish: "ڕاپۆرتی سندوق",
    arabic: " تقرير الصندوق",
    english: "Box Report",
  },
  {
    user_key: "Total Repayments in dollars and dinars",
    kurdish: "کۆی گشتی پارەوەرگرتنەکان بە دۆلار و دینار",
    arabic: " إجمالي التسديدات بالدولار والدينار",
    english: "Total Repayments in dollars and dinars",
  },
  {
    user_key: "Total payments in dollars and dinars",
    kurdish: "کۆی گشتی پارەپێدانەکان بە دۆلار و دینار",
    arabic: " إجمالي المدفوعات بالدولار والدينار",
    english: "Total payments in dollars and dinars",
  },
  {
    user_key: "Total expenses and monthly money",
    kurdish: "کۆی گشتی خەرجییەکان و پارەی مانگانە",
    arabic: " إجمالي المصروفات والنقود الشهرية",
    english: "Total expenses and monthly money",
  },
  {
    user_key: "The total amount of money that came out of the money",
    kurdish: "کۆی گشتی پارەی هاتوو پارەی دەرچوو",
    arabic: " المبلغ الإجمالي للمال الذي خرج من المال",
    english: "The total amount of money that came out of the money",
  },
  {
    user_key: "Total rewards and penalties",
    kurdish: "کۆی گشتی نسبەکان و پاداشت و سزاکان",
    arabic: " إجمالي المكافآت والعقوبات",
    english: "Total rewards and penalties",
  },
  {
    user_key: "Employee General Report",
    kurdish: "ڕاپۆرتی گشتی کارمەند",
    arabic: "التقرير العام للموظف",
    english: "Employee General Report",
  },
  {
    user_key: "Sell Contract",
    kurdish: "گرێبەستی فرۆشتن",
    arabic: "العقود المباعة",
    english: "Sell Contracts",
  },
  {
    user_key: "Rental contract_",
    kurdish: "گرێبەستی کرێیەکان",
    arabic: "عقد الإيجار",
    english: "Rental Contracts",
  },
  {
    user_key: "Registration Property",
    kurdish: "داخیلکردنی موڵک",
    arabic: "تسجيل العقار",
    english: "Registration Property",
  },
  {
    user_key: "Total_Sell_Contracts",
    kurdish: "کۆی گرێبەستی فرۆشتن",
    arabic: "إجمالي عقود البيع",
    english: "Total Sell Contracts",
  },
  {
    user_key: "User",
    kurdish: "بەکارهێنەر",
    arabic: "مستخدم",
    english: "User",
  },
  {
    user_key: "property owner",
    kurdish: "خاوەنی موڵك",
    arabic: "مالك العقار",
    english: "property owner",
  },
  {
    user_key: "tenant",
    kurdish: "کرێچی",
    arabic: "المستأجر",
    english: "tenant",
  },
  {
    user_key: "Go to the box.",
    kurdish: "بچێتە سندوق",
    arabic: "اذهب إلى المربع",
    english: "Go to the box",
  },
  {
    user_key: "Get out of the box",
    kurdish: "بچێتە دەر لە سندوق",
    arabic: "اخرج من الصندوق",
    english: "Get out of the box",
  },
  {
    user_key: "off",
    kurdish: "نەخێر",
    arabic: "لا",
    english: "No",
  },
  {
    user_key: "on",
    kurdish: "بەڵێ",
    arabic: "نعم",
    english: "Yes",
  },
  {
    user_key: "accountant",
    kurdish: "ژمێریار",
    arabic: "محاسب",
    english: "accountant",
  },
  {
    user_key: "Expenses $",
    kurdish: "خەرجی بە دۆلار",
    arabic: "النفقات $",
    english: "Expenses $",
  },
  {
    user_key: "Expenses ID",
    kurdish: "خەرجی بە دینار",
    arabic: "النفقات ID",
    english: "Expenses ID",
  },
  {
    user_key: "Buyer",
    kurdish: "کڕیار",
    arabic: "المشتري",
    english: "Buyer",
  },
  {
    user_key: "Saler",
    kurdish: "فرۆشیار",
    arabic: "البائع",
    english: "seller",
  },
  {
    user_key: "Tenant",
    kurdish: "کرێچی",
    arabic: "المستأجر",
    english: "Tenant",
  },
  {
    user_key: "Owner",
    kurdish: "خاوەن موڵك",
    arabic: "اسم المالك",
    english: "Owner",
  },
  {
    user_key: "list of clients",
    kurdish: "لیستی زەبوونەکان",
    arabic: "قائمة العملاء",
    english: "list of clients",
  },
  {
    user_key: "currency price",
    kurdish: "نرخی دراو",
    arabic: "سعر العملة",
    english: "currency price",
  },
  {
    user_key: "List of dollar price changes",
    kurdish: "لیستی گۆڕینی نرخی دۆلار",
    arabic: "قائمة تغيرات أسعار الدولار",
    english: "List of dollar price changes",
  },
  {
    user_key: "Price Change",
    kurdish: "گۆڕینی نرخ",
    arabic: "تغير السعر",
    english: "Price Change",
  },
  {
    user_key: "The current price of the dollar",
    kurdish: "نرخی ئێستای دۆلار",
    arabic: "السعر الحالي للدولار",
    english: "The current price of the dollar",
  },
  {
    user_key: "1 Dolar Price",
    kurdish: "نرخی 1 دۆلار",
    arabic: "السعر 1 دولار",
    english: "1 Dolar Price",
  },
  {
    user_key: "Income Report",
    kurdish: "ڕاپۆرتی داهات",
    arabic: "تقرير الدخل",
    english: "Income Report",
  },
  {
    user_key: "Code by Number",
    kurdish: "کۆد بە ژمارە",
    arabic: "الرمز حسب الرقم",
    english: "Code by Number",
  },
  {
    user_key: "Code by Letter",
    kurdish: "کۆد بە پیت",
    arabic: "رمز بحرف",
    english: "Code by Letter",
  },
  {
    user_key: "Code Number",
    kurdish: "کۆد ژمارە",
    arabic: "الرمز الرقم",
    english: "Code Number",
  },
  {
    user_key: "Code Letter",
    kurdish: "کۆد پیت",
    arabic: "رمز بحرف",
    english: "Code Letter",
  },
  {
    user_key: "newest payment",
    kurdish: "کرێیە نوێیەکان",
    arabic: "أحدث دفعة",
    english: "newest payment",
  },
  {
    user_key: "overdue rentals",
    kurdish: "کرێیە دواکەوتووەکان",
    arabic: "الإيجارات المتأخرة",
    english: "overdue rentals",
  },
  {
    user_key: "List of rental times",
    kurdish: "کاتی ‌هێنانی کرێ",
    arabic: "حان الوقت لدفع الإيجار",
    english: "List of rental times",
  },
  //
  {
    user_key: "List of commercial contracts",
    kurdish: "لیستی گرێبەستی بازرگانی",
    arabic: "قائمة العقود التجارية",
    english: "List of commercial contracts",
  },
  {
    user_key: "commercial contracts",
    kurdish: "گرێبەستی بازرگانی",
    arabic: "العقود التجارية",
    english: "commercial contracts",
  },
  // list tenants
  {
    user_key: "newest payment_",
    kurdish: "لیستی کرێیە نوێیەکان",
    arabic: "قائمة أحدث دفعة",
    english: "newest payment",
  },
  {
    user_key: "overdue rentals_",
    kurdish: "کرێیە دواکەوتووەکان",
    arabic: "قائمة الإيجارات المتأخرة",
    english: "overdue rentals",
  },
  {
    user_key: "List of rental times_",
    kurdish: "لیستی کاتی ‌هێنانی کرێ",
    arabic: "قائمة حان الوقت لدفع الإيجار",
    english: "List of rental times",
  },
];

export default lang_agent;
